import React, { useEffect, useMemo, useState } from 'react';
import { toast } from 'sonner';
import { ArrowLeft, Building2, ChevronDown, ChevronRight, Layers3, Plus, Users, X, UploadCloud, CheckCircle2, AlertTriangle, GitCompare, Stethoscope, Settings, Trash2, Database, Boxes, Package, Pencil, Search, Activity } from 'lucide-react';
import ZonaNav from '../app/ZonaNav';
import { saasApi, errText, isSuperAdmin, descargarInformeCarga } from './api';
import { useDescargas } from './useDescarga';
import { PasosCarga } from './PasosCarga';
import MaestroReconciliation from './MaestroReconciliation';
import ActualizacionSuscripciones from './ActualizacionSuscripciones';

const go=(p)=>{window.history.pushState({},'',p);window.dispatchEvent(new PopStateEvent('popstate'));};

function ReconciliacionCanales(){
  const [canal,setCanal]=useState('actualizacion');
  return <div className="space-y-4">
    <div className="inline-flex rounded-xl border overflow-hidden bg-white" data-testid="tabs-canales-reconciliacion">
      <button data-testid="tab-canal-actualizacion" onClick={()=>setCanal('actualizacion')}
        className={`px-4 py-2 text-sm font-bold ${canal==='actualizacion'?'bg-[#0a6640] text-white':'text-slate-700'}`}>
        Actualización de suscripciones
      </button>
      <button data-testid="tab-canal-maestro" onClick={()=>setCanal('maestro')}
        className={`px-4 py-2 text-sm font-bold ${canal==='maestro'?'bg-[#0a6640] text-white':'text-slate-700'}`}>
        MAESTRO histórico
      </button>
    </div>
    <div className="text-xs text-slate-500">
      {canal==='actualizacion'
        ? 'Nuevo canal · sube el XLSX generado desde Control con el estado actual de las suscripciones.'
        : 'Canal histórico · sigue aceptando el MAESTRO SaaS (SAAS_MIGRACION + STOCK).'}
    </div>
    {canal==='actualizacion' ? <ActualizacionSuscripciones/> : <MaestroReconciliation/>}
  </div>;
}

export default function SaaSAdmin({onLogout}){
  const [tab,setTab]=useState('clientes');
  const superAdmin = isSuperAdmin();
  // Iter52.62 · B7 · El importador inicial está desactivado en producción:
  // la pestaña solo aparece en Preview (donde se usa para poblar tras borrar).
  const [importadorActivo,setImportadorActivo]=useState(null);
  useEffect(()=>{
    let vivo=true;
    saasApi.get('/saas/admin/importacion-maestro/estado-entorno')
      .then(r=>{ if(vivo) setImportadorActivo(!!r.data?.importador_inicial_activo); })
      .catch(()=>{ if(vivo) setImportadorActivo(false); });
    return ()=>{vivo=false;};
  },[]);
  const tabs = [['clientes','Clientes Operativos',Building2],['grupos','Grupos',Users],['familias','Familias',Layers3]];
  if (importadorActivo) tabs.push(['importacion','Importación inicial',UploadCloud]);
  tabs.push(['reconciliacion','Reconciliación',GitCompare]);
  if (superAdmin) {
    tabs.push(['catalogo','Catálogo',Package]);
    tabs.push(['catalogo-geotab','Catálogo Geotab',Boxes]);
    tabs.push(['ajustes','Ajustes',Stethoscope]);
    tabs.push(['ajustes-preview','Ajustes Preview',Settings]);
    // Iter52.69 · Rama 17 · Registro de actividad (solo super_admin).
    tabs.push(['actividad','Actividad',Activity]);
  }
  return <div className="min-h-screen bg-slate-50">
    <header className="bg-[#0a6640] px-5 py-3"><div className="max-w-[1400px] mx-auto flex justify-between items-center"><div><p className="text-xs text-white/60 uppercase font-bold">Administración</p><h1 className="text-white font-bold text-lg">Operaciones SaaS</h1></div><ZonaNav activa="admin" onLogout={onLogout}/></div></header>
    <main className="max-w-[1400px] mx-auto p-6">
      <button className="text-sm text-slate-500 flex gap-2 items-center mb-5" onClick={()=>go('/admin/saas/inicio')}><ArrowLeft className="w-4 h-4"/>Volver a Operaciones SaaS</button>
      <div className="flex gap-2 mb-5 flex-wrap">{tabs.map(([k,l,I])=><button key={k} data-testid={`tab-${k}`} onClick={()=>setTab(k)} className={`px-4 py-2 rounded-xl border flex gap-2 items-center ${tab===k?'bg-[#0a6640] text-white border-[#0a6640]':'bg-white'}`}><I className="w-4 h-4"/>{l}</button>)}</div>
      {tab==='clientes'&&<Clientes/>}{tab==='grupos'&&<Grupos/>}{tab==='familias'&&<Familias/>}{tab==='importacion'&&importadorActivo&&<ImportacionMaestro/>}{tab==='reconciliacion'&&<ReconciliacionCanales/>}{tab==='catalogo'&&<CatalogoProductos/>}{tab==='catalogo-geotab'&&<CatalogoGeotab/>}{tab==='ajustes'&&<Ajustes/>}{tab==='ajustes-preview'&&<AjustesPreview/>}{tab==='actividad'&&superAdmin&&<Actividad/>}
    </main>
  </div>;
}

function Clientes(){
  const [items,setItems]=useState([]),[grupos,setGrupos]=useState([]),[q,setQ]=useState(''),[grupo,setGrupo]=useState(''),[activo,setActivo]=useState(''),[edit,setEdit]=useState(null);
  const [cifImportOpen,setCifImportOpen]=useState(false);
  const [inicio,setInicio]=useState(null); // Iter52.35 · para badge consistencia
  // Iter52.36 · Modal de suscripciones huérfanas
  const [huerfanasOpen,setHuerfanasOpen]=useState(false);
  const [huerfanas,setHuerfanas]=useState(null);
  const [loadingHuer,setLoadingHuer]=useState(false);
  const abrirHuerfanas=async()=>{
    setHuerfanasOpen(true);
    setLoadingHuer(true);
    try{
      const r=await saasApi.get('/saas/suscripciones/huerfanas');
      setHuerfanas(r.data);
    }catch(e){toast.error(errText(e));setHuerfanas({items:[],total:0})}
    finally{setLoadingHuer(false)}
  };
  // Iter52.31 · Orden inicial por Suscripciones (mayor→menor). El usuario
  // puede cambiar el criterio clicando en cualquier cabecera; al recargar
  // la pantalla vuelve a arrancar así.
  const [sortKey,setSortKey]=useState('num_suscripciones');
  const [sortDir,setSortDir]=useState('desc');
  const load=async()=>{try{
    const [c,g,ini]=await Promise.all([
      saasApi.get('/saas/clientes-operativos',{params:{q:q||undefined,grupo_id:grupo||undefined,activo:activo===''?undefined:activo==='true',page_size:200}}),
      saasApi.get('/saas/grupos?page_size=200'),
      saasApi.get('/saas/inicio/dashboard').catch(()=>({data:null})),
    ]);
    setItems(c.data.items||[]);setGrupos(g.data.items||[]);
    setInicio(ini.data?.suscripciones||null);
  }catch(e){toast.error(errText(e))}};
  useEffect(()=>{load()},[]);
  const save=async(f)=>{try{
    let resp;
    if(f.id) resp = await saasApi.patch(`/saas/clientes-operativos/${f.id}`,f);
    else resp = await saasApi.post('/saas/clientes-operativos',f);
    // Iter52.50 · Rama · CIF repetible: backend puede devolver un
    // aviso naranja no bloqueante si otra ficha usa el mismo CIF.
    if(resp?.data?.warning){
      toast.warning(resp.data.warning, {duration: 6000});
    } else {
      toast.success('Cliente guardado');
    }
    // Iter52.81 · 2 · Aviso de posible ficha duplicada por nombre.
    const sim = resp?.data?.similares || [];
    if(sim.length){
      toast.warning(`Nombre parecido a: ${sim.map(s=>s.razon_social).join(', ')}`, {duration: 8000});
    }
    setEdit(null);load();
  }catch(e){toast.error(errText(e))}};
  const toggle=(k)=>{if(sortKey===k) setSortDir(sortDir==='asc'?'desc':'asc'); else{setSortKey(k);setSortDir(k==='num_suscripciones'||k==='num_pipeline'||k==='num_dispositivos'?'desc':'asc');}};
  const grupoNombre=(id)=> grupos.find(g=>g.id===id)?.nombre || '';
  const sorted = useMemo(()=>{
    const arr = [...items];
    const dir = sortDir==='asc'?1:-1;
    // Iter52.31 · Para `factura_a`: "" y "Varios" van SIEMPRE al final,
    // en ambos sentidos (asc/desc). El resto ordena alfabético.
    const facturaRank = (v)=> !v ? 2 : (v==='Varios' ? 1 : 0);
    const val = (x)=>{
      switch(sortKey){
        case 'grupo': return grupoNombre(x.grupo_id).toLowerCase();
        case 'num_suscripciones': return Number(x.num_suscripciones||0);
        case 'num_pipeline': return Number(x.num_pipeline||0);
        case 'num_dispositivos': return Number(x.num_dispositivos||0);
        case 'factura_a': return String(x.factura_a||'').toLowerCase();
        case 'estado': return x.activo===false?'Inactivo':'Activo';
        default: return String(x[sortKey]||'').toLowerCase();
      }
    };
    arr.sort((a,b)=>{
      if(sortKey==='factura_a'){
        const ra=facturaRank(a.factura_a), rb=facturaRank(b.factura_a);
        if(ra!==rb) return ra-rb;
      }
      const va=val(a),vb=val(b); if(va<vb)return -dir; if(va>vb)return dir; return 0;
    });
    return arr;
  }, [items, sortKey, sortDir, grupos]);
  // Iter52.35 · Badge de consistencia con Inicio
  const sumaSubs = useMemo(()=>items.reduce((a,x)=>a+Number(x.num_suscripciones||0),0),[items]);
  const sumaPipe = useMemo(()=>items.reduce((a,x)=>a+Number(x.num_pipeline||0),0),[items]);
  const iniActivas = Number(inicio?.activas||0);
  const iniSusp = Number(inicio?.suspendidas||0);
  const iniPipe = Number(inicio?.pipeline||0);
  const iniVivas = Number(inicio?.vivas||0);
  const consistente = inicio && sumaSubs===(iniActivas+iniSusp) && sumaPipe===iniPipe && (sumaSubs+sumaPipe)===iniVivas;
  const filtradoActivo = !!(q||grupo||activo!=='');
  const H = ({k, children, right=false})=> <th onClick={()=>toggle(k)} className={`cursor-pointer select-none ${right?'text-right':''}`} data-testid={`th-clientes-${k}`}>{children} <span className="text-slate-400 text-[10px]">{sortKey===k?(sortDir==='asc'?'▲':'▼'):''}</span></th>;
  return <Box title="Clientes Operativos" onAdd={()=>setEdit({razon_social:'',nombre_comercial:'',cif:'',grupo_id:'',modelo_facturacion:'ANTICIPADO',email_facturacion:'',activo:true})}>
    <div className="flex flex-wrap gap-2 mb-4"><input className="input max-w-sm" placeholder="Buscar razón social, CIF…" value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>e.key==='Enter'&&load()}/><select className="input max-w-56" value={grupo} onChange={e=>setGrupo(e.target.value)}><option value="">Todos los grupos</option>{grupos.map(g=><option key={g.id} value={g.id}>{g.nombre}</option>)}</select><select className="input max-w-44" value={activo} onChange={e=>setActivo(e.target.value)}><option value="">Todos</option><option value="true">Activos</option><option value="false">Inactivos</option></select><button className="btn-secondary" onClick={load}>Filtrar</button>
      <button data-testid="btn-cargar-cif-excel" className="btn-secondary ml-auto" onClick={()=>setCifImportOpen(true)}>Cargar CIF (Excel)</button>
    </div>
    {cifImportOpen && <CifImportModal onClose={()=>{setCifImportOpen(false);load()}}/>}
    {inicio && !filtradoActivo && <div className="mb-2 flex flex-wrap items-center gap-2">
      <div data-testid="badge-consistencia-inicio" className={`text-xs inline-flex items-center gap-2 px-3 py-1.5 rounded-full border ${consistente?'bg-emerald-50 border-emerald-200 text-emerald-800':'bg-amber-50 border-amber-200 text-amber-800'}`}>
        <span className="font-semibold">{iniVivas} vivas</span>
        <span>= {sumaSubs} subs + {sumaPipe} pipeline</span>
        <span>·</span>
        {consistente
          ? <span title="Las sumas de la tabla cuadran con Inicio.">✓ consistente con Inicio</span>
          : <span title={`Inicio: activas=${iniActivas} susp=${iniSusp} pipe=${iniPipe} vivas=${iniVivas}`}>⚠ divergencia con Inicio</span>}
      </div>
      {!consistente && <button
        data-testid="btn-ver-huerfanas"
        className="text-xs px-3 py-1.5 rounded-full border border-amber-300 bg-white text-amber-800 hover:bg-amber-50"
        onClick={abrirHuerfanas}
        title="Lista las suscripciones cuyo cliente de servicio no existe en Clientes Operativos"
      >Ver suscripciones huérfanas</button>}
    </div>}
    <div className="text-xs text-slate-500 mb-2">Las filas en gris no tienen suscripciones activas como cliente de servicio — pueden ser clientes de facturación, recién creados, o históricos.</div>
    <div className="overflow-auto border rounded-xl">
      <table className="table text-sm" data-testid="tabla-clientes-operativos">
        <thead className="bg-slate-50">
          <tr>
            <H k="razon_social">Razón social</H>
            <H k="cif">CIF</H>
            <H k="grupo">Grupo</H>
            <H k="num_suscripciones" right>Suscripciones</H>
            <H k="num_pipeline" right>Pipeline</H>
            <H k="num_dispositivos" right>Dispositivos</H>
            <H k="factura_a">Factura a</H>
            <H k="modelo_facturacion">Facturación</H>
            <H k="estado">Estado</H>
            <th></th>
          </tr>
        </thead>
        <tbody>{sorted.map(x=>{
          const enCero = Number(x.num_suscripciones||0)===0;
          return <tr key={x.id} className={enCero?'bg-slate-50 text-slate-500':''} data-testid={enCero?`row-cli-cero-${x.id}`:`row-cli-${x.id}`}>
            <td>{x.razon_social}</td>
            <td>{x.cif}</td>
            <td>{grupoNombre(x.grupo_id)||'—'}</td>
            <td className="text-right font-mono" data-testid={`td-num-suscripciones-${x.id}`}>{x.num_suscripciones ?? 0}</td>
            <td className="text-right font-mono" data-testid={`td-num-pipeline-${x.id}`}>{x.num_pipeline ?? 0}</td>
            <td className="text-right font-mono">{x.num_dispositivos ?? 0}</td>
            <td data-testid={`td-factura-a-${x.id}`} className={x.factura_a==='Varios'?'text-amber-700 font-medium':''}>{x.factura_a || '—'}</td>
            <td data-testid={`cell-tipo-factura-${x.id}`}>
              {x.modelo_facturacion==='USO_GEOTAB'?'Factura uso SaaS':'Factura servicio (anticipada)'}
              {/* Iter52.88 · A · Marca visible en la tabla. */}
              {x.abono_por_suspension && <span data-testid={`tag-abono-suspension-${x.id}`}
                className="ml-2 text-[10px] font-bold uppercase tracking-wide text-sky-800 bg-sky-50 border border-sky-200 rounded px-1.5 py-0.5">
                Abono por suspensión
              </span>}
              {x.cliente_interno && <span data-testid={`tag-cliente-interno-${x.id}`}
                className="ml-2 text-[10px] font-bold uppercase tracking-wide text-violet-800 bg-violet-50 border border-violet-200 rounded px-1.5 py-0.5">
                Interno
              </span>}
            </td>
            <td>{x.activo===false?<span className="text-slate-500">Inactivo</span>:'Activo'}</td>
            <td><button className="link" onClick={()=>setEdit({...x})}>Editar</button></td>
          </tr>;
        })}</tbody>
      </table>
    </div>
    {edit&&<ClienteModal value={edit} grupos={grupos} onClose={()=>setEdit(null)} onSave={save}/>}
    {huerfanasOpen&&<Modal title="Suscripciones huérfanas" onClose={()=>setHuerfanasOpen(false)}>
      <div className="text-sm text-slate-600 mb-3">
        Suscripciones vivas cuyo <span className="font-mono text-xs bg-slate-100 px-1 rounded">cliente_servicio_id</span> no corresponde a ningún cliente operativo existente. Reasigna el cliente correcto desde la ficha de cada suscripción, o márcalas para revisión.
      </div>
      {loadingHuer && <div className="text-center py-6 text-slate-500">Cargando…</div>}
      {!loadingHuer && huerfanas && <>
        <div className="text-xs text-slate-500 mb-2">
          {huerfanas.total===0 ? 'No hay huérfanas — el badge debería estar en verde.' : `${huerfanas.total} suscripción${huerfanas.total===1?'':'es'} huérfana${huerfanas.total===1?'':'s'}${huerfanas.truncado?' (lista truncada al límite)':''}`}
        </div>
        {huerfanas.total>0 && <div className="overflow-auto max-h-[60vh] border rounded" data-testid="tabla-huerfanas">
          <table className="table text-sm">
            <thead className="bg-slate-50 sticky top-0"><tr>
              <th>ID Suscripción</th>
              <th>Estado</th>
              <th>Plan Geotab</th>
              <th>Dispositivo</th>
              <th>Cliente servicio (huérfano)</th>
            </tr></thead>
            <tbody>{huerfanas.items.map(h=><tr key={h.id} data-testid={`row-huerfana-${h.id}`}>
              <td className="font-mono text-xs" title={h.id}>{h.id?.slice(0,8)}…</td>
              <td>{h.estado}</td>
              <td>{h.plan_geotab_codigo_origen||<span className="text-rose-600">— sin plan</span>}</td>
              <td className="text-xs">
                {h.serial_geotab||h.matricula||h.id_pack_origen||<span className="text-slate-400">—</span>}
                {h.dispositivo_id && <div className="font-mono text-[10px] text-slate-400" title={h.dispositivo_id}>{h.dispositivo_id.slice(0,8)}…</div>}
              </td>
              <td className="font-mono text-xs text-rose-700" title={h.cliente_servicio_id_huerfano}>{h.cliente_servicio_id_huerfano||'—'}</td>
            </tr>)}</tbody>
          </table>
        </div>}
      </>}
      <div className="flex justify-end mt-4"><button className="btn-secondary" onClick={()=>setHuerfanasOpen(false)}>Cerrar</button></div>
    </Modal>}
  </Box>;
}


function CifImportModal({onClose}){
  const [file,setFile]=useState(null);
  const [preview,setPreview]=useState(null);
  const [motivo,setMotivo]=useState('Carga masiva CIF · maestro');
  const [busy,setBusy]=useState(false);
  const onPreview=async()=>{
    if(!file) return toast.error('Selecciona un Excel');
    setBusy(true);
    try{
      const fd = new FormData(); fd.append('archivo', file);
      const r = await saasApi.post('/saas/clientes-operativos/cif-import/preview', fd);
      setPreview(r.data);
    }catch(e){toast.error(errText(e))} finally{setBusy(false)}
  };
  const onApply=async()=>{
    if(!preview) return;
    if(motivo.trim().length<10) return toast.error('Motivo mínimo 10 caracteres');
    setBusy(true);
    try{
      const rows = preview.filas.filter(f=>['CAMBIA','AVISO_CIF_REPETIDO'].includes(f.estado));
      const r = await saasApi.post('/saas/clientes-operativos/cif-import/apply', {rows, motivo});
      toast.success(`Aplicadas ${r.data.aplicadas} · saltadas ${r.data.saltadas}`);
      onClose();
    }catch(e){toast.error(errText(e))} finally{setBusy(false)}
  };
  const cnt = preview?.resumen || {};
  return <Modal title="Cargar CIF (Excel)" onClose={onClose}>
    <div className="space-y-3">
      <div className="text-sm text-slate-600">
        Columnas requeridas: <code>CLIENTE_ID</code> y <code>CIF</code>. Filas con CIF vacío se ignoran.
      </div>
      <input data-testid="cif-import-file" type="file" accept=".xlsx" onChange={e=>{setFile(e.target.files?.[0]||null);setPreview(null)}}/>
      <button data-testid="cif-import-preview" className="btn-secondary" onClick={onPreview} disabled={!file||busy}>Previsualizar</button>
      {preview && <>
        <div className="grid grid-cols-3 gap-2 text-xs">
          <div className="rounded p-2 bg-emerald-50 border border-emerald-200">CAMBIA: <b>{cnt.cambia||0}</b></div>
          <div className="rounded p-2 bg-slate-50 border border-slate-200">SIN CAMBIO: <b>{cnt.sin_cambio||0}</b></div>
          <div className="rounded p-2 bg-amber-50 border border-amber-200">CIF REPETIDO: <b>{cnt.aviso_cif_repetido||0}</b></div>
          <div className="rounded p-2 bg-rose-50 border border-rose-200 col-span-3">RECHAZADAS: <b>{(cnt.rechazada_cliente_no_encontrado||0)+(cnt.rechazada_formato||0)}</b></div>
        </div>
        <div className="max-h-64 overflow-auto text-xs">
          <table className="table"><thead><tr><th>CLIENTE_ID</th><th>Razón social</th><th>CIF actual</th><th>CIF propuesto</th><th>Estado</th></tr></thead><tbody>
            {preview.filas.map((r,i)=><tr key={i} className={r.estado.startsWith('RECHAZADA')?'text-rose-700':r.estado==='AVISO_CIF_REPETIDO'?'text-amber-700':''}>
              <td>{r.cliente_id}</td><td>{r.razon_social||'-'}</td><td>{r.cif_actual||'-'}</td><td>{r.cif_propuesto||'-'}</td><td title={r.motivo||''}>{r.estado}</td>
            </tr>)}
          </tbody></table>
        </div>
        <Field label="Motivo (obligatorio, ≥10 caracteres)"><input className="input" value={motivo} onChange={e=>setMotivo(e.target.value)}/></Field>
        <div className="flex justify-end gap-2">
          <button className="btn-secondary" onClick={onClose}>Cancelar</button>
          <button data-testid="cif-import-apply" className="btn-primary" disabled={busy||((cnt.cambia||0)+(cnt.aviso_cif_repetido||0))===0} onClick={onApply}>Aplicar</button>
        </div>
      </>}
    </div>
  </Modal>;
}


function ClienteModal({value,grupos,onClose,onSave}){
  const [f,setF]=useState(value);
  // Iter52.48b · Rama 21 · "Tipo de factura" ANTICIPADO/USO_GEOTAB.
  // Deriva `modalidad_facturacion` (ANTICIPADO→ANTICIPADA · USO_GEOTAB→VENCIDA)
  // en el mismo guardado. Motivo obligatorio si se cambia en edición.
  const initialModelo = value.modelo_facturacion || (value.modalidad_facturacion==='VENCIDA'?'USO_GEOTAB':'ANTICIPADO');
  const [tipoFact,setTipoFact] = useState(initialModelo);
  const [motivoModelo,setMotivoModelo] = useState('');
  const [similares,setSimilares] = useState([]);
  const cambia = f.id && tipoFact !== initialModelo;
  const submit = ()=>{
    if (cambia && (!motivoModelo || motivoModelo.trim().length < 10)) {
      toast.error('Motivo obligatorio (mínimo 10 caracteres) al cambiar el tipo de factura');
      return;
    }
    // Derivar modalidad y limpiar campos que no aplican al PATCH/POST.
    const modalidad = tipoFact === 'USO_GEOTAB' ? 'VENCIDA' : 'ANTICIPADA';
    const payload = {...f, modelo_facturacion: tipoFact, modalidad_facturacion: modalidad};
    if (cambia) payload.motivo_modelo_facturacion = motivoModelo.trim();
    onSave(clean(payload));
  };
  // Iter52.81 · 2 · Consulta de solo lectura al salir de la razón social.
  const buscarSimilares = async () => {
    const nombre = (f.razon_social||'').trim();
    if (nombre.length < 3) { setSimilares([]); return; }
    try {
      const r = await saasApi.get('/saas/clientes-operativos/similares',
        { params: { nombre, excluir_id: f.id || undefined } });
      setSimilares(r.data?.similares || []);
    } catch { setSimilares([]); }
  };
  return <Modal title={f.id?'Editar Cliente Operativo':'Nuevo Cliente Operativo'} onClose={onClose}>
    <div className="grid md:grid-cols-2 gap-4">
      <Field label="Razón social *"><input className="input" data-testid="input-razon-social" value={f.razon_social||''} onChange={e=>setF({...f,razon_social:e.target.value})} onBlur={buscarSimilares}/></Field>
      {/* Iter52.81 · 2 · Aviso (no bloqueante) de posible ficha duplicada. */}
      {similares.length>0 && <div className="md:col-span-2 text-xs bg-amber-50 border border-amber-300 rounded-lg p-3 text-amber-900" data-testid="aviso-cliente-duplicado">
        <b>Puede que esta ficha ya exista.</b> Nombres parecidos ({similares.length}):
        <ul className="mt-1 space-y-0.5">{similares.map(s=><li key={s.id}>
          · <a className="underline font-semibold" href={`/admin/saas/dispositivos?cliente_id=${s.id}`} target="_blank" rel="noreferrer" data-testid={`link-cliente-similar-${s.id}`}>{s.razon_social}</a>
          {s.nombre_comercial?` · ${s.nombre_comercial}`:''} <span className="text-amber-700">({s.tipo})</span>
        </li>)}</ul>
        <span className="text-amber-700">Puedes continuar igualmente.</span>
      </div>}
      <Field label="Nombre comercial"><input className="input" value={f.nombre_comercial||''} onChange={e=>setF({...f,nombre_comercial:e.target.value})}/></Field>
      <Field label="CIF *"><input className="input" value={f.cif||''} onChange={e=>setF({...f,cif:e.target.value})}/></Field>
      <Field label="Grupo"><select className="input" value={f.grupo_id||''} onChange={e=>setF({...f,grupo_id:e.target.value||null})}><option value="">Sin grupo</option>{grupos.map(g=><option key={g.id} value={g.id}>{g.nombre}</option>)}</select></Field>
      <Field label="Tipo de factura *">
        <select className="input" data-testid="select-tipo-factura" value={tipoFact} onChange={e=>setTipoFact(e.target.value)}>
          <option value="ANTICIPADO">Factura servicio (anticipada)</option>
          <option value="USO_GEOTAB">Factura uso SaaS</option>
        </select>
      </Field>
      {/* Iter52.88 · A · Marca para Control Geotab, independiente del modelo. */}
      <Field label="Abono por suspensión (Control Geotab)">
        <label className="flex items-start gap-2 text-sm">
          <input type="checkbox" className="mt-1" data-testid="check-abono-suspension"
            checked={!!f.abono_por_suspension}
            onChange={e=>setF({...f,abono_por_suspension:e.target.checked})}/>
          <span className="text-slate-600">
            Marca los clientes a los que se les calcula el abono por suspensiones con la factura de Geotab.
            Es independiente de si facturan por adelantado o por uso.
          </span>
        </label>
      </Field>
      {/* Iter52.93 · T2 · Cliente interno: sus equipos son los «propios», con
          suscripción a 0 €. Es la única marca que permite precio 0 € en un
          traspaso; el código nunca identifica al interno por su nombre. */}
      <Field label="Cliente interno (equipos propios)">
        <label className="flex items-start gap-2 text-sm">
          <input type="checkbox" className="mt-1" data-testid="check-cliente-interno"
            checked={!!f.cliente_interno}
            onChange={e=>setF({...f,cliente_interno:e.target.checked})}/>
          <span className="text-slate-600">
            Los equipos propios cuelgan de este cliente con su suscripción a 0 €.
            Solo con esta marca se admite un traspaso con precio 0 €.
          </span>
        </label>
      </Field>
      <Field label="Forma de pago *">
        <select className="input" data-testid="select-forma-pago" value={f.forma_pago||'TRANSFERENCIA'} onChange={e=>{
          const forma=e.target.value;
          // Iter52.53 · A1 · DOMICILIACION fuerza antelación a 0.
          setF({...f, forma_pago: forma, meses_antelacion_renovacion: forma==='DOMICILIACION' ? 0 : (f.meses_antelacion_renovacion||0)});
        }}>
          <option value="TRANSFERENCIA">Transferencia</option>
          <option value="DOMICILIACION">Domiciliación</option>
        </select>
      </Field>
      <Field label="Meses de antelación de la renovación">
        <input className="input" data-testid="input-meses-antelacion" type="number" min="0" step="1"
          disabled={(f.forma_pago||'TRANSFERENCIA')==='DOMICILIACION'}
          value={f.meses_antelacion_renovacion ?? 0}
          onChange={e=>setF({...f, meses_antelacion_renovacion: Math.max(0, parseInt(e.target.value||'0',10))})}/>
        <div data-testid="ayuda-antelacion" className="mt-1 text-xs text-slate-600">
          {(f.forma_pago||'TRANSFERENCIA')==='DOMICILIACION'
            ? 'Domiciliación: la factura sale el 01 del mes siguiente al fin de prepago.'
            : (() => {
                const ant = parseInt(f.meses_antelacion_renovacion||0, 10) || 0;
                // Ejemplo con fin 30/09: día siguiente = 01/10; restamos antelación.
                let y=2027, m=10 - ant; while(m<=0){m+=12; y-=1;}
                const mm = String(m).padStart(2,'0');
                return `Un prepago que vence el 30/09 se facturará el 01/${mm}${ant>0?' ('+ant+' m. de antelación)':''}.`;
              })()}
        </div>
      </Field>
      <Field label="Email facturación"><input className="input" type="email" value={f.email_facturacion||''} onChange={e=>setF({...f,email_facturacion:e.target.value})}/></Field>
      {f.id && <Field label="Estado"><select className="input" value={String(f.activo!==false)} onChange={e=>setF({...f,activo:e.target.value==='true'})}><option value="true">Activo</option><option value="false">Inactivo</option></select></Field>}
      {cambia && <Field label="Motivo del cambio de tipo de factura *">
        <textarea className="input" data-testid="input-motivo-tipo-factura" rows="2" placeholder="Explica por qué cambia el tipo de factura (mín. 10 caracteres)" value={motivoModelo} onChange={e=>setMotivoModelo(e.target.value)}/>
      </Field>}
    </div>
    <div className="flex justify-end gap-2 mt-6">
      <button className="btn-secondary" onClick={onClose}>Cancelar</button>
      <button className="btn-primary" data-testid="btn-guardar-cliente" onClick={submit}>Guardar</button>
    </div>
  </Modal>;
}

function Grupos(){
  const [items,setItems]=useState([]),[edit,setEdit]=useState(null);
  const [clientesGrupo,setClientesGrupo]=useState([]);
  const [loadingClientes,setLoadingClientes]=useState(false);
  const load=async()=>{try{setItems((await saasApi.get('/saas/grupos?page_size=200')).data.items||[])}catch(e){toast.error(errText(e))}};
  useEffect(()=>{load()},[]);
  const save=async(f)=>{try{if(f.id)await saasApi.patch(`/saas/grupos/${f.id}`,clean(f));else await saasApi.post('/saas/grupos',clean(f));setEdit(null);setClientesGrupo([]);load()}catch(e){toast.error(errText(e))}};
  const openEdit=async(x)=>{
    setEdit({...x});
    setClientesGrupo([]);
    if(x?.id){
      setLoadingClientes(true);
      try{
        const r=await saasApi.get(`/saas/grupos/${x.id}/clientes`);
        setClientesGrupo(r.data.items||[]);
      }catch(e){toast.error(errText(e))}
      finally{setLoadingClientes(false)}
    }
  };
  return <Box title="Grupos" onAdd={()=>{setEdit({nombre:'',notas:'',activo:true});setClientesGrupo([])}}>
    <Simple headers={['Grupo','Estado','']} rows={items.map(x=>[x.nombre, x.activo===false?'Inactivo':'Activo', <button className="link" onClick={()=>openEdit(x)}>Editar</button>])}/>
    {edit&&<Modal title={edit.id?'Editar grupo':'Nuevo grupo'} onClose={()=>{setEdit(null);setClientesGrupo([])}}>
      <div className="space-y-4">
        <Field label="Nombre *"><input data-testid="input-grupo-nombre" className="input" value={edit.nombre||''} onChange={e=>setEdit({...edit,nombre:e.target.value})}/></Field>
        <Field label="Notas"><textarea className="input min-h-24" value={edit.notas||''} onChange={e=>setEdit({...edit,notas:e.target.value})}/></Field>
        {edit.id&&<Field label="Estado"><select className="input" value={String(edit.activo!==false)} onChange={e=>setEdit({...edit,activo:e.target.value==='true'})}><option value="true">Activo</option><option value="false">Inactivo</option></select></Field>}
        {edit.id&&<div className="mt-2 border-t pt-4" data-testid="grupo-clientes-panel">
          <div className="flex items-center justify-between mb-2">
            <h4 className="font-semibold text-slate-700">Clientes operativos del grupo</h4>
            <span className="text-xs text-slate-500">{loadingClientes?'Cargando…':`${clientesGrupo.length} cliente${clientesGrupo.length!==1?'s':''}`}</span>
          </div>
          {!loadingClientes && clientesGrupo.length===0 && <div className="text-sm text-slate-500 py-3 text-center bg-slate-50 rounded">Este grupo aún no tiene clientes asignados.</div>}
          {clientesGrupo.length>0 && <div className="overflow-auto max-h-80 border rounded">
            <table className="table text-sm">
              <thead className="bg-slate-50 sticky top-0"><tr>
                <th>Cliente de servicio</th>
                <th>CIF</th>
                <th>Factura a</th>
                <th>Estado</th>
              </tr></thead>
              <tbody>{clientesGrupo.map(c=><tr key={c.id}>
                <td>{c.razon_social}</td>
                <td className="font-mono text-xs">{c.cif||'—'}</td>
                <td className={c.factura_a==='Varios'?'text-amber-700 font-medium':''}>{c.factura_a||'—'}</td>
                <td>{c.activo===false?<span className="text-slate-500">Inactivo</span>:'Activo'}</td>
              </tr>)}</tbody>
            </table>
          </div>}
        </div>}
        <div className="flex justify-end gap-2 mt-2"><button className="btn-secondary" onClick={()=>{setEdit(null);setClientesGrupo([])}}>Cancelar</button><button data-testid="btn-guardar-grupo" className="btn-primary" onClick={()=>save(edit)}>Guardar</button></div>
      </div>
    </Modal>}
  </Box>;
}

function Familias(){
  const [items,setItems]=useState([]),[edit,setEdit]=useState(null);const load=async()=>{try{const r=await saasApi.get('/saas/config/familias-dispositivo');setItems(Array.isArray(r.data)?r.data:(r.data.items||[]))}catch(e){toast.error(errText(e))}};useEffect(()=>{load()},[]);
  const save=async(f)=>{try{if(f.id){const {id,codigo,...rest}=clean(f);await saasApi.patch(`/saas/config/familias-dispositivo/${id}`,rest)}else await saasApi.post('/saas/config/familias-dispositivo',clean(f));setEdit(null);load()}catch(e){toast.error(errText(e))}};
  return <Box title="Familias funcionales" onAdd={()=>setEdit({codigo:'',nombre:'',naturaleza_default:'FISICO',cuenta_flota:false,permite_saas:true,requiere_suscripcion:null,activo:true})}><Simple headers={['Código','Nombre','Naturaleza','Cuenta flota','Permite SaaS','Requiere suscripción','Estado','']} rows={items.map(x=>[x.codigo,x.nombre,x.naturaleza_default,x.cuenta_flota?'Sí':'No',x.permite_saas?'Sí':'No',x.requiere_suscripcion===true?'Sí':x.requiere_suscripcion===false?'No':<span className="text-rose-600 font-bold" data-testid="familia-sin-clasificar">Sin clasificar</span>,x.activo===false?'Inactiva':'Activa',<button className="link" onClick={()=>setEdit({...x})}>Editar</button>])}/>{edit&&<Modal title={edit.id?'Editar familia':'Nueva familia'} onClose={()=>setEdit(null)}><div className="grid md:grid-cols-2 gap-4"><Field label="Código *"><input className="input" disabled={!!edit.id} value={edit.codigo||''} onChange={e=>setEdit({...edit,codigo:e.target.value})}/></Field><Field label="Nombre *"><input className="input" value={edit.nombre||''} onChange={e=>setEdit({...edit,nombre:e.target.value})}/></Field><Field label="Naturaleza"><select className="input" value={edit.naturaleza_default||'FISICO'} onChange={e=>setEdit({...edit,naturaleza_default:e.target.value})}><option>FISICO</option><option>VIRTUAL</option></select></Field><Field label="Cuenta como flota"><select className="input" value={String(!!edit.cuenta_flota)} onChange={e=>setEdit({...edit,cuenta_flota:e.target.value==='true'})}><option value="false">No</option><option value="true">Sí</option></select></Field><Field label="Permite SaaS"><select className="input" value={String(edit.permite_saas!==false)} onChange={e=>setEdit({...edit,permite_saas:e.target.value==='true'})}><option value="true">Sí</option><option value="false">No</option></select></Field><Field label="Requiere suscripción (obligatorio)"><select data-testid="familia-requiere-suscripcion" className="input" value={edit.requiere_suscripcion===true?'true':edit.requiere_suscripcion===false?'false':''} onChange={e=>setEdit({...edit,requiere_suscripcion:e.target.value===''?null:e.target.value==='true'})}><option value="">Sin clasificar (bloquea el alta)</option><option value="true">Sí · el alta exige SaaS + tarifa</option><option value="false">No · admite alta sin SaaS (p.ej. Ureader)</option></select></Field><Field label="Estado"><select className="input" value={String(edit.activo!==false)} onChange={e=>setEdit({...edit,activo:e.target.value==='true'})}><option value="true">Activa</option><option value="false">Inactiva</option></select></Field></div><div className="flex justify-end mt-5"><button className="btn-primary" onClick={()=>save(edit)}>Guardar</button></div></Modal>}</Box>;
}


function ImportacionMaestro(){
  const [maestro,setMaestro]=useState(null),[stock,setStock]=useState(null),[res,setRes]=useState(null),[loading,setLoading]=useState(false),[confirm,setConfirm]=useState(''),[history,setHistory]=useState([]),[precargaRes,setPrecargaRes]=useState(null),[precargaAt,setPrecargaAt]=useState(null),[validadoAt,setValidadoAt]=useState(null);
  const loadHistory=async()=>{try{setHistory((await saasApi.get('/saas/admin/importacion-maestro/historial')).data.items||[])}catch(e){}};
  useEffect(()=>{loadHistory()},[]);
  const data=()=>{const fd=new FormData();fd.append('maestro',maestro);if(stock)fd.append('stock',stock);return fd};
  const invalidateValidation=()=>{setRes(null);setValidadoAt(null);setConfirm('');};
  const doPrecarga=async()=>{if(!maestro)return toast.error('Selecciona primero el MAESTRO');setLoading(true);setPrecargaRes(null);try{const fd=new FormData();fd.append('maestro',maestro);const r=await saasApi.post('/saas/admin/importacion-maestro/precarga-clientes',fd,{headers:{'Content-Type':'multipart/form-data'}});setPrecargaRes(r.data);setPrecargaAt(Date.now());invalidateValidation();toast.success(`Precarga: ${r.data.clientes_creados} nuevos + ${r.data.clientes_ya_existentes} ya existentes. Ahora vuelve a "Validar" antes de importar.`)}catch(e){toast.error(errText(e))}finally{setLoading(false)}};
  const validate=async()=>{if(!maestro)return toast.error('Selecciona el MAESTRO normalizado');setLoading(true);setRes(null);try{const r=await saasApi.post('/saas/admin/importacion-maestro/validar',data(),{headers:{'Content-Type':'multipart/form-data'}});setRes(r.data);setValidadoAt(Date.now());toast.success('Validación completada')}catch(e){toast.error(errText(e))}finally{setLoading(false)}};
  const commit=async()=>{if(!maestro||confirm!=='IMPORTAR MAESTRO')return;if(precargaAt&&(!validadoAt||validadoAt<precargaAt)){toast.error('Debes revalidar tras la precarga');return}setLoading(true);try{const fd=data();fd.append('confirmacion',confirm);const r=await saasApi.post('/saas/admin/importacion-maestro/importar',fd,{headers:{'Content-Type':'multipart/form-data'}});setRes(r.data);toast.success(`Importación completada: ${r.data.import_id||''}`);setConfirm('');loadHistory()}catch(e){toast.error(errText(e))}finally{setLoading(false)}};
  const requiereRevalidar=!!precargaAt&&(!validadoAt||validadoAt<precargaAt);
  const bloqueadoImportar=loading||!res||!res.puede_importar||confirm!=='IMPORTAR MAESTRO'||requiereRevalidar;
  // Iter52.15 · Estado de los 3 pasos (guía visual)
  const paso1Done = !!precargaAt;
  const paso2Done = !!validadoAt && !requiereRevalidar && !!res;
  const paso2OK   = paso2Done && res && res.puede_importar;
  // Paso actual (el primero pendiente)
  const pasoActual = !paso1Done ? 1 : (!paso2Done ? 2 : 3);
  return <div className="space-y-5">
    <div className="bg-white border rounded-2xl p-5">
      <div className="flex items-start gap-3"><UploadCloud className="w-6 h-6 mt-1"/><div><h2 className="text-xl font-black">Importación inicial del MAESTRO</h2><p className="text-sm text-slate-500 mt-1">Flujo obligatorio en 3 pasos. Sigue el indicador de progreso.</p></div></div>

      {/* Stepper horizontal 1—2—3 */}
      <div data-testid="stepper-import" className="mt-5 flex items-center gap-2 flex-wrap">
        {[
          {n:1,label:'Precargar Clientes + Grupos',done:paso1Done},
          {n:2,label:'Validar MAESTRO',done:paso2Done,warn:paso2Done&&!paso2OK},
          {n:3,label:'Escribir "IMPORTAR MAESTRO"',done:false},
        ].map((s,i,arr)=>{
          const isCurrent = pasoActual===s.n;
          const state = s.done ? 'done' : (isCurrent ? 'current' : 'pending');
          const circleCls = {
            done: 'bg-emerald-500 text-white border-emerald-500',
            current: 'bg-slate-900 text-white border-slate-900',
            pending: 'bg-white text-slate-400 border-slate-300',
          }[state];
          const labelCls = {
            done: 'text-emerald-700',
            current: 'text-slate-900 font-bold',
            pending: 'text-slate-400',
          }[state];
          return <React.Fragment key={s.n}>
            <div data-testid={`stepper-paso-${s.n}`} data-state={state} className="flex items-center gap-2">
              <span className={`inline-flex items-center justify-center w-8 h-8 rounded-full border-2 font-bold text-sm ${circleCls}`}>
                {s.done ? '✓' : s.n}
              </span>
              <span className={`text-sm ${labelCls}`}>Paso {s.n} · {s.label}{s.warn&&<span className="ml-1 text-amber-600">(con bloqueantes)</span>}</span>
            </div>
            {i<arr.length-1 && <span className={`hidden md:inline-block h-px w-8 ${arr[i].done?'bg-emerald-400':'bg-slate-300'}`}/>}
          </React.Fragment>;
        })}
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-5">
        <Field label="MAESTRO normalizado (.xlsx) *"><input data-testid="file-maestro" className="input" type="file" accept=".xlsx,.xlsm" onChange={e=>{setMaestro(e.target.files?.[0]||null);invalidateValidation();setPrecargaRes(null);setPrecargaAt(null)}}/></Field>
        <Field label="MAESTRO original / STOCK (.xlsm) — opcional"><input data-testid="file-stock" className="input" type="file" accept=".xlsx,.xlsm" onChange={e=>{setStock(e.target.files?.[0]||null);invalidateValidation()}}/></Field>
      </div>
      <p className="text-xs text-slate-500 mb-4">El archivo STOCK solo se usa para enriquecer asociaciones cuando existan. La ausencia de GO asociado a un ID PACK no es un error ni un incumplimiento.</p>
      <div className="flex flex-wrap gap-2">
        <button data-testid="btn-precarga-clientes" className={pasoActual===1?"btn-primary":"btn-secondary"} disabled={loading||!maestro} onClick={doPrecarga}>{loading?'…':`${paso1Done?'✓ ':''}1) Precargar Clientes Operativos + Grupos`}</button>
        <button data-testid="btn-validar-maestro" className={pasoActual===2?"btn-primary":"btn-secondary"} disabled={loading||!maestro||!paso1Done} onClick={validate}>{loading?'Validando…':`${paso2Done?'✓ ':''}2) Validar antes de importar`}</button>
      </div>
      {!paso1Done&&<p className="text-xs text-slate-500 mt-2">Empieza por el <b>Paso 1</b>. El Paso 2 se desbloqueará al terminar la precarga.</p>}
      {precargaRes&&<div className="mt-4 bg-emerald-50 border border-emerald-200 rounded-xl p-4 text-sm text-emerald-800"><b>Precarga completada</b> · Grupos: {precargaRes.grupos_creados} nuevos / {precargaRes.grupos_totales} totales · Clientes: {precargaRes.clientes_creados} nuevos + {precargaRes.clientes_ya_existentes} ya existentes = {precargaRes.clientes_totales} totales. Modalidad inicial <code>ANTICIPADA</code>. CIFs cargados como <code>PENDIENTE-XXXXXXXX</code> para completar después.</div>}
      {requiereRevalidar&&<div data-testid="banner-revalidar" className="mt-3 bg-amber-50 border border-amber-300 rounded-xl p-4 text-sm text-amber-900"><b>⚠ Vuelve a pulsar "Validar"</b> · La precarga cambió la base de clientes; la validación anterior ya no es válida.</div>}
    </div>
    {res&&<div className="bg-white border rounded-2xl p-5">
      <div className="flex items-center gap-2 mb-4">{res.puede_importar?<CheckCircle2 className="w-5 h-5"/>:<AlertTriangle className="w-5 h-5"/>}<h3 className="font-black text-lg">Resultado de validación</h3></div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {[
          ['Total', res.total],
          ['Nuevas', res.nuevas],
          ['Idénticas ya importadas', res.identicas],
          ['Modificadas (bloqueadas)', res.modificadas],
          ['Bloqueadas cliente', res.bloqueadas_cliente_cif],
          ['Bloqueadas estado destino', res.bloqueadas_estado_destino],
          ['Bloqueadas idempotencia', res.bloqueadas_idempotencia],
          ['Bloqueadas duplicado archivo', res.bloqueadas_duplicado_archivo],
          ['Producto SaaS pendiente', res.producto_pendiente_no_bloqueante],
          ['Cliente servicio pendiente', res.cliente_servicio_pendiente_no_bloqueante],
          ['ÚNICO / excepción', res.excepciones_unico],
          ['Prepago anual', res.prepagos_anuales],
        ].map(([l, v]) => <div key={l} className="border rounded-xl p-3"><div className="text-xs text-slate-500">{l}</div><div className="text-2xl font-black">{v ?? 0}</div></div>)}
      </div>
      {!!res.bloqueantes?.length && <div className="mt-4"><p className="font-bold mb-2">Primeros bloqueantes</p><Simple headers={['Fila','Cliente','Motivo','Valor']} rows={res.bloqueantes.slice(0,20).map(x=>[x.fila||'—',x.cliente||'—',x.motivo,x.valor||'—'])}/></div>}
      {!!res.filas_modificadas_detalle?.length && <div className="mt-4"><p className="font-bold mb-2">Filas modificadas (no se actualizan automáticamente)</p><Simple headers={['Fila','Campo','Valor actual','Valor nuevo']} rows={res.filas_modificadas_detalle.slice(0,20).flatMap(m => m.diferencias.map(d => [m.fila, d.campo === 'ASOCIACION_STOCK' ? 'Asociación STOCK' : d.campo, String(d.anterior ?? '—'), String(d.nuevo ?? '—')]))}/></div>}
      {/* Paso 3 · sólo cuando Paso 2 está sin bloqueantes */}
      {paso2OK ? <div className="mt-5 border-t pt-5" data-testid="paso-3-importar">
        <p className="font-bold text-slate-900">✓ Validación sin bloqueantes · Último paso</p>
        <p className="text-sm text-slate-500 mb-3">Solo Admin/Superadmin. Escribe exactamente <b>IMPORTAR MAESTRO</b> para confirmar la importación.</p>
        <div className="flex flex-wrap gap-2 items-center"><input data-testid="txt-confirm-import" className="input max-w-xs" value={confirm} onChange={e=>setConfirm(e.target.value)} placeholder="IMPORTAR MAESTRO"/><button data-testid="btn-import-maestro" className="btn-primary" disabled={bloqueadoImportar} onClick={commit}>3) Importar datos</button></div>
      </div> : <div className="mt-5 border-t pt-5" data-testid="paso-3-bloqueado">
        <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 text-sm text-slate-600"><b>Paso 3 · Importar</b> — bloqueado hasta que la validación termine sin bloqueantes. Revisa los motivos arriba y vuelve a validar cuando estén resueltos.</div>
      </div>}
    </div>}
    <div className="bg-white border rounded-2xl p-5"><h3 className="font-black text-lg mb-3">Historial de importaciones</h3><Simple headers={['Fecha','Importación','Archivo','Usuario','Estado','Insertadas','Fallidas','Idénticas']} rows={history.map(x=>[String(x.created_at||'').slice(0,19).replace('T',' '),x.import_id,x.file||'—',x.created_by||'—',x.estado||'—',x.stats_post?.inserted??'—',x.stats_post?.failed??'—',x.stats_post?.identicas_omitidas??'—'])}/></div>
  </div>;
}

// Iter52.8c · Paso 0 · Diagnóstico de tipos (solo superadmin) ------------
function DiagnosticoTipos(){
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(false);
  const [lastAt,setLastAt]=useState(null);
  const lanzar=async()=>{
    setLoading(true);
    try{
      const r = await saasApi.get('/saas/admin/saneamiento-tipos/diagnostico');
      setData(r.data);
      setLastAt(new Date().toLocaleString('es-ES'));
      toast.success('Diagnóstico completado');
    }catch(e){toast.error(errText(e));}
    finally{setLoading(false);}
  };
  useEffect(()=>{lanzar();/* eslint-disable-next-line */},[]);
  const totalMal = data ? Object.values(data.colecciones||{}).reduce((acc,col)=>acc+Object.values(col.campos||{}).reduce((a,c)=>a+(c.mal_tipados||0),0),0) : 0;
  return <div className="space-y-4" data-testid="tab-diagnostico-tipos">
    <div className="bg-white border rounded-2xl p-5">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h2 className="text-xl font-black flex items-center gap-2"><Stethoscope className="w-5 h-5 text-emerald-600"/>Diagnóstico de tipos de dato</h2>
          <p className="text-sm text-slate-500 mt-1">Barrido read-only de las colecciones críticas del módulo SaaS. Cuenta los documentos cuyo tipo real difiere del tipo canónico esperado. No modifica nada.</p>
        </div>
        <button data-testid="btn-diagnostico-relanzar" className="btn-secondary" onClick={lanzar} disabled={loading}>{loading?'Analizando…':'Volver a analizar'}</button>
      </div>
      {data && <div className="grid sm:grid-cols-3 gap-3 mt-4">
        <div className="border rounded-xl p-3"><p className="text-xs uppercase text-slate-500">Colecciones auditadas</p><p className="text-2xl font-black">{data.total_colecciones}</p></div>
        <div className="border rounded-xl p-3"><p className="text-xs uppercase text-slate-500">Docs totales</p><p className="text-2xl font-black">{Object.values(data.colecciones||{}).reduce((a,c)=>a+(c.total_docs||0),0)}</p></div>
        <div className={`border rounded-xl p-3 ${totalMal>0?'bg-rose-50 border-rose-300':'bg-emerald-50 border-emerald-300'}`}><p className="text-xs uppercase text-slate-500">Campos mal tipados (total)</p><p className={`text-2xl font-black ${totalMal>0?'text-rose-700':'text-emerald-700'}`}>{totalMal}</p></div>
      </div>}
      {lastAt && <p className="text-xs text-slate-400 mt-2">Última consulta · {lastAt}</p>}
    </div>
    {data && Object.entries(data.colecciones||{}).map(([col,info])=>{
      const campos = Object.entries(info.campos||{});
      const malTipadosColeccion = campos.reduce((a,[,c])=>a+(c.mal_tipados||0),0);
      return <div key={col} className="bg-white border rounded-2xl overflow-hidden" data-testid={`diag-coleccion-${col}`}>
        <div className={`px-5 py-3 flex justify-between border-b ${malTipadosColeccion>0?'bg-rose-50':'bg-emerald-50'}`}>
          <span className="font-black">{col}</span>
          <span className="text-xs text-slate-600">{info.total_docs} docs · <b className={malTipadosColeccion>0?'text-rose-700':'text-emerald-700'}>{malTipadosColeccion} campos mal tipados</b></span>
        </div>
        <div className="overflow-auto">
          <table className="table">
            <thead><tr><th>Campo</th><th>Tipo esperado</th><th>Tipos reales</th><th>Mal tipados</th></tr></thead>
            <tbody>{campos.map(([k,c])=><tr key={k} className={(c.mal_tipados||0)>0?'bg-rose-50':''}>
              <td className="font-mono text-xs">{k}</td>
              <td><code className="text-xs bg-slate-100 px-1.5 py-0.5 rounded">{c.tipo_esperado}</code></td>
              <td className="text-xs">{Object.entries(c.tipos_reales||{}).map(([t,n])=><span key={t} className={`inline-block mr-2 px-1.5 py-0.5 rounded ${t===c.tipo_esperado||t==='null'?'bg-slate-100':'bg-rose-100 text-rose-700 font-bold'}`}>{t}:{n}</span>)}</td>
              <td className="font-bold">{(c.mal_tipados||0)>0?<span className="text-rose-700">{c.mal_tipados}</span>:<span className="text-emerald-700">0</span>}</td>
            </tr>)}</tbody>
          </table>
        </div>
      </div>;
    })}
  </div>;
}


// ============================================================================
// Iter52.11 · Ajustes (super_admin) · agrupa herramientas de mantenimiento
// que aplican TANTO en Preview como en Producción. De momento sólo el
// Diagnóstico de tipos.
// ============================================================================
// ============================================================================
// Iter52.23 · Reconciliar grupos por nombre (super_admin) · dry-run + apply.
// Cuadra la vista de dirección de Rentabilidad cuando `grupo_id` de clientes
// apunta a `saas_grupos` huérfanos por reimportaciones sucesivas.
// ============================================================================
function ReconciliarGrupos(){
  const [plan,setPlan]=useState(null);
  const [loading,setLoading]=useState(false);
  const [applying,setApplying]=useState(false);
  const cargarPlan=async()=>{
    setLoading(true);
    try{
      const r = await saasApi.get('/saas/admin/reconciliar-grupos/diagnostico');
      setPlan(r.data);
      toast.success('Diagnóstico completado');
    }catch(e){toast.error(errText(e));}
    finally{setLoading(false);}
  };
  const aplicar=async()=>{
    if(!plan || plan.resumen.grupos_a_fusionar===0){
      toast.info('No hay nada que fusionar.');
      return;
    }
    const ok = window.confirm(`Se van a fusionar ${plan.resumen.grupos_a_fusionar} grupos duplicados y reasignar ${plan.resumen.clientes_reasignados} clientes al grupo canónico. Los ${plan.resumen.sin_grupo_resoluble} huérfanos puros NO se tocan (revisión manual). ¿Confirmas?`);
    if(!ok) return;
    setApplying(true);
    try{
      const r = await saasApi.post('/saas/admin/reconciliar-grupos/aplicar');
      toast.success(`Fusiones aplicadas: ${r.data.fusiones_aplicadas}. Clientes reasignados: ${r.data.resumen.clientes_reasignados_efectivos}.`);
      await cargarPlan(); // re-diagnóstico, debería quedar en 0 duplicados
    }catch(e){toast.error(errText(e));}
    finally{setApplying(false);}
  };
  useEffect(()=>{cargarPlan();/* eslint-disable-next-line */},[]);
  const R = plan?.resumen || {};
  return <div className="space-y-4" data-testid="tab-reconciliar-grupos">
    <div className="bg-white border rounded-2xl p-5">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h2 className="text-xl font-black flex items-center gap-2"><Stethoscope className="w-5 h-5 text-amber-600"/>Reconciliar grupos por nombre</h2>
          <p className="text-sm text-slate-500 mt-1">Colapsa duplicados de <code>saas_grupos</code> con el mismo nombre normalizado (reimportaciones sucesivas) y reasigna los <code>grupo_id</code> de los clientes al canónico. El canónico se elige por número de clientes referenciándolo. Huérfanos puros se listan aparte para revisión manual — no se inventa grupo.</p>
        </div>
        <div className="flex gap-2">
          <button data-testid="btn-recon-grupos-diagnostico" className="btn-secondary" onClick={cargarPlan} disabled={loading}>{loading?'Analizando…':'Volver a diagnosticar'}</button>
          <button data-testid="btn-recon-grupos-aplicar" className="btn-danger" onClick={aplicar} disabled={applying||!plan||plan.resumen.grupos_a_fusionar===0}>{applying?'Aplicando…':`Aplicar reconciliación (${R.grupos_a_fusionar||0} grupos)`}</button>
        </div>
      </div>
      {plan && <div className="grid sm:grid-cols-5 gap-3 mt-4">
        <div className="border rounded-xl p-3"><p className="text-xs uppercase text-slate-500">Grupos totales</p><p className="text-2xl font-black">{R.grupos_totales}</p></div>
        <div className="border rounded-xl p-3"><p className="text-xs uppercase text-slate-500">Familias con duplicados</p><p className="text-2xl font-black">{R.familias_con_duplicados}</p></div>
        <div className={`border rounded-xl p-3 ${R.grupos_a_fusionar>0?'bg-amber-50 border-amber-300':'bg-emerald-50 border-emerald-300'}`}><p className="text-xs uppercase text-slate-500">Grupos a fusionar</p><p className={`text-2xl font-black ${R.grupos_a_fusionar>0?'text-amber-700':'text-emerald-700'}`}>{R.grupos_a_fusionar}</p></div>
        <div className="border rounded-xl p-3"><p className="text-xs uppercase text-slate-500">Clientes a reasignar</p><p className="text-2xl font-black">{R.clientes_reasignados}</p></div>
        <div className={`border rounded-xl p-3 ${R.sin_grupo_resoluble>0?'bg-rose-50 border-rose-300':'bg-slate-50'}`}><p className="text-xs uppercase text-slate-500">Sin grupo resoluble</p><p className={`text-2xl font-black ${R.sin_grupo_resoluble>0?'text-rose-700':''}`}>{R.sin_grupo_resoluble}</p></div>
      </div>}
    </div>
    {plan?.fusiones?.length>0 && <div className="bg-white border rounded-2xl overflow-hidden" data-testid="recon-grupos-fusiones">
      <div className="px-5 py-3 border-b bg-amber-50"><span className="font-black">Fusiones propuestas ({plan.fusiones.length})</span></div>
      <div className="overflow-auto max-h-[420px]">
        <table className="table">
          <thead><tr><th>Nombre normalizado</th><th>Canónico</th><th>Fusionados</th><th className="text-right">Clientes reasignados</th></tr></thead>
          <tbody>{plan.fusiones.map((f,i)=>
            <tr key={i}>
              <td className="font-mono text-xs">{f.nombre_normalizado}</td>
              <td><b>{f.canonico.nombre}</b> · <span className="text-xs text-slate-500">{f.canonico.clientes} clientes</span></td>
              <td className="text-xs">{f.fusionados.map(g=><div key={g.id}><span className="text-slate-600">{g.nombre}</span> <span className="text-slate-400">· {g.clientes} clientes · <code className="bg-slate-100 px-1 rounded text-[10px]">{g.id.slice(0,8)}</code></span></div>)}</td>
              <td className="text-right font-bold">{f.clientes_reasignados}</td>
            </tr>)}
          </tbody>
        </table>
      </div>
    </div>}
    {plan?.sin_grupo_resoluble?.length>0 && <div className="bg-white border rounded-2xl overflow-hidden" data-testid="recon-grupos-huerfanos">
      <div className="px-5 py-3 border-b bg-rose-50 flex items-center justify-between">
        <span className="font-black">Clientes con grupo huérfano puro ({plan.sin_grupo_resoluble.length})</span>
        <span className="text-xs text-slate-600">Su <code>grupo_id</code> no está en <code>saas_grupos</code>. Revisa manualmente y reasígnalos desde la ficha del cliente.</span>
      </div>
      <div className="overflow-auto max-h-[300px]">
        <table className="table">
          <thead><tr><th>Cliente</th><th>grupo_id huérfano</th></tr></thead>
          <tbody>{plan.sin_grupo_resoluble.slice(0,200).map((h,i)=>
            <tr key={i}><td>{h.razon_social}</td><td><code className="text-xs bg-slate-100 px-1 rounded">{h.grupo_id_huerfano}</code></td></tr>)}
          </tbody>
        </table>
        {plan.sin_grupo_resoluble.length>200 && <p className="text-xs text-slate-500 p-2">… {plan.sin_grupo_resoluble.length-200} más</p>}
      </div>
    </div>}
  </div>;
}


// Iter52.55 · Punto 1 · Normalización de periodos PREPAGO (causa raíz):
// guarda `fecha_fin` canónica en los que no la tienen y pasa las fechas de
// periodo a medianoche. Idempotente: relanzarla no cambia nada.
function NormalizarPrepago(){
  const [data,setData]=useState(null);
  const [busy,setBusy]=useState(false);
  const cargar=async()=>{setBusy(true);try{
    const r=await saasApi.get('/saas/admin/normalizar-prepago/diagnostico');
    setData(r.data);
  }catch(e){toast.error(errText(e));}finally{setBusy(false);}};
  const ejecutar=async(dry)=>{
    if(!dry && !window.confirm('Se escribirá `fecha_fin` en los periodos PREPAGO que no la tengan y se normalizarán las fechas a medianoche. ¿Continuar?'))return;
    setBusy(true);
    try{
      const r=await saasApi.post(`/saas/admin/normalizar-prepago/migrar?dry_run=${dry?'true':'false'}`);
      setData({antes:r.data.antes, despues:r.data.despues,
               por_cliente_fecha_fin:r.data.por_cliente_fecha_fin,
               por_cliente_normalizar_hora:r.data.por_cliente_normalizar_hora,
               sin_fecha_fin_ni_calculable:r.data.sin_fecha_fin_ni_calculable,
               resultado:r.data});
      toast.success(dry
        ? `Simulación · ${r.data.corregidos_fecha_fin} fechas fin + ${r.data.normalizados_medianoche} normalizaciones`
        : `Migrado · ${r.data.corregidos_fecha_fin} fechas fin + ${r.data.normalizados_medianoche} normalizaciones`);
    }catch(e){toast.error(errText(e));}finally{setBusy(false);}
  };
  useEffect(()=>{cargar();/* eslint-disable-next-line */},[]);
  const a=data?.antes||{};
  return <div className="bg-white border rounded-2xl p-5" data-testid="panel-normalizar-prepago">
    <div className="flex items-start justify-between gap-4 flex-wrap">
      <div>
        <h2 className="text-xl font-black">Normalizar periodos PREPAGO</h2>
        <p className="text-sm text-slate-500 mt-1">Guarda la <code>fecha_fin</code> canónica en los periodos PREPAGO que no la tengan y pasa las fechas de periodo a medianoche. Idempotente y neutra para la facturación: elimina el cálculo del fin al vuelo.</p>
      </div>
      <div className="flex gap-2">
        <button data-testid="btn-normalizar-prepago-diag" className="btn-secondary" onClick={cargar} disabled={busy}>{busy?'…':'Analizar'}</button>
        <button data-testid="btn-normalizar-prepago-dry" className="btn-secondary" onClick={()=>ejecutar(true)} disabled={busy}>Simular</button>
        <button data-testid="btn-normalizar-prepago-apply" className="btn-danger" onClick={()=>ejecutar(false)} disabled={busy||!(a.a_rellenar||a.con_hora_a_normalizar)}>Aplicar</button>
      </div>
    </div>
    {data&&<div className="grid sm:grid-cols-4 gap-3 mt-4 text-center">
      <div className="border rounded-xl p-3"><p className="text-xs uppercase text-slate-500">Periodos PREPAGO</p><p className="text-2xl font-black" data-testid="np-prepago">{a.periodos_prepago||0}</p></div>
      <div className={`border rounded-xl p-3 ${(a.a_rellenar||0)>0?'bg-amber-50 border-amber-300':'bg-emerald-50 border-emerald-300'}`}><p className="text-xs uppercase text-slate-500">Sin fecha fin (a rellenar)</p><p className="text-2xl font-black" data-testid="np-a-rellenar">{a.a_rellenar||0}</p></div>
      <div className={`border rounded-xl p-3 ${(a.con_hora_a_normalizar||0)>0?'bg-amber-50 border-amber-300':'bg-emerald-50 border-emerald-300'}`}><p className="text-xs uppercase text-slate-500">Con hora (a medianoche)</p><p className="text-2xl font-black" data-testid="np-con-hora">{a.con_hora_a_normalizar||0}</p></div>
      <div className={`border rounded-xl p-3 ${(a.sin_fecha_fin_ni_calculable||0)>0?'bg-rose-50 border-rose-300':''}`}><p className="text-xs uppercase text-slate-500">No calculables</p><p className="text-2xl font-black" data-testid="np-no-calculables">{a.sin_fecha_fin_ni_calculable||0}</p></div>
    </div>}
    {data?.despues&&<p className="text-xs text-slate-500 mt-2">Después · a rellenar {data.despues.a_rellenar} · con hora {data.despues.con_hora_a_normalizar}</p>}
    {!!(data?.por_cliente_fecha_fin||[]).length&&<div className="mt-4 overflow-auto max-h-64 border rounded-xl">
      <table className="table text-xs"><thead><tr><th>Cliente</th><th className="text-right">Periodos a corregir</th></tr></thead>
        <tbody>{data.por_cliente_fecha_fin.map((r,i)=><tr key={i}><td>{r.cliente}</td><td className="text-right tabular-nums font-bold">{r.periodos}</td></tr>)}</tbody></table>
    </div>}
  </div>;
}


// ============================================================================
// Iter52.56 · Rama 27 · A1 · Catálogo de productos (HW y SaaS) gestionado
// SOLO desde Operaciones SaaS. Ofertas y Admin lo leen. Misma colección y
// mismos ids: sin migración de datos y sin impacto en facturación.
// ============================================================================
const TIPOS_PROD = [['hw','HW'],['saas','SaaS'],['instalacion','Instalación'],['servicio','Servicio']];

function CatalogoProductos(){
  const [items,setItems]=useState([]); const [enUso,setEnUso]=useState({});
  const [planes,setPlanes]=useState([]);
  const [loading,setLoading]=useState(true);
  const [q,setQ]=useState(''); const [fTipo,setFTipo]=useState(''); const [fEstado,setFEstado]=useState('activo');
  const [edit,setEdit]=useState(null); const [retirar,setRetirar]=useState(null);
  const cargar=async()=>{setLoading(true);try{
    const [a,b,c]=await Promise.all([
      saasApi.get('/configuracion-fase2/catalogo'),
      saasApi.get('/configuracion-fase2/catalogo/en-uso'),
      saasApi.get('/saas/admin/catalogo-geotab/planes').catch(()=>({data:{items:[]}})),
    ]);
    setItems(a.data||[]); setEnUso(b.data?.en_uso||{});
    const pl=c.data?.items||c.data||[];
    setPlanes(Array.isArray(pl)?pl:[]);
  }catch(e){toast.error(errText(e));}finally{setLoading(false);}};
  useEffect(()=>{cargar();},[]);
  const filtrados=useMemo(()=>items.filter(p=>{
    if(fTipo&&p.tipo!==fTipo)return false;
    if(fEstado==='activo'&&p.activo===false)return false;
    if(fEstado==='retirado'&&p.activo!==false)return false;
    const t=(q||'').toLowerCase().trim();
    if(t&&!`${p.sku||''} ${p.nombre||''} ${p.categoria||''}`.toLowerCase().includes(t))return false;
    return true;
  }),[items,q,fTipo,fEstado]);
  const guardar=async(p,motivo)=>{
    try{
      if(p.id){
        const body={nombre:p.nombre,categoria:p.categoria,coste:Number(p.coste||0),precio:Number(p.precio||0),
                    unidad:p.unidad||'ud',plan_geotab_habitual:p.plan_geotab_habitual||null,
                    va_sobre_geotab:p.va_sobre_geotab!==false,
                    sku:p.sku,tipo:p.tipo};
        if(motivo)body.motivo=motivo;
        await saasApi.put(`/configuracion-fase2/catalogo/${p.id}`,body);
      }else{
        await saasApi.post('/configuracion-fase2/catalogo',{sku:p.sku,nombre:p.nombre,tipo:p.tipo,
          categoria:p.categoria||null,coste:Number(p.coste||0),precio:Number(p.precio||0),
          unidad:p.unidad||'ud',plan_geotab_habitual:p.plan_geotab_habitual||null,
          va_sobre_geotab:p.va_sobre_geotab!==false});
      }
      toast.success('Catálogo actualizado'); setEdit(null); cargar();
    }catch(e){toast.error(errText(e));}
  };
  const cambiarEstado=async(p,motivo)=>{
    try{
      await saasApi.put(`/configuracion-fase2/catalogo/${p.id}`,{activo:p.activo===false,motivo});
      toast.success(p.activo===false?'Producto reactivado':'Producto retirado');
      setRetirar(null); cargar();
    }catch(e){toast.error(errText(e));}
  };
  return <div className="space-y-4" data-testid="tab-catalogo-productos">
    <div className="bg-white border rounded-2xl p-5">
      <div className="flex justify-between items-start gap-4 flex-wrap">
        <div>
          <h2 className="text-xl font-black">Catálogo de productos</h2>
          <p className="text-sm text-slate-500 mt-1">HW y SaaS. Se gestiona aquí; Ofertas y Administración solo lo leen. Cambiar el precio de lista <b>no</b> toca suscripciones ni ofertas existentes: cada una factura su precio pactado.</p>
        </div>
        <button data-testid="btn-catalogo-nuevo" className="btn-primary" onClick={()=>setEdit({tipo:'saas',unidad:'ud',coste:0,precio:0})}><Plus className="w-4 h-4"/>Nuevo producto</button>
      </div>
      <div className="flex gap-2 mt-4 flex-wrap">
        <div className="relative"><Search className="w-4 h-4 absolute left-3 top-3 text-slate-400"/>
          <input data-testid="catalogo-buscar" className="input pl-9" placeholder="Código, nombre o categoría…" value={q} onChange={e=>setQ(e.target.value)}/></div>
        <select data-testid="catalogo-filtro-tipo" className="input max-w-[180px]" value={fTipo} onChange={e=>setFTipo(e.target.value)}>
          <option value="">Todos los tipos</option>{TIPOS_PROD.map(([v,l])=><option key={v} value={v}>{l}</option>)}</select>
        <select data-testid="catalogo-filtro-estado" className="input max-w-[180px]" value={fEstado} onChange={e=>setFEstado(e.target.value)}>
          <option value="activo">Activos</option><option value="retirado">Retirados</option><option value="">Todos</option></select>
        <span className="text-xs text-slate-500 self-center">{filtrados.length} productos</span>
      </div>
    </div>
    <div className="bg-white border rounded-2xl overflow-hidden" data-testid="tabla-catalogo-productos">
      <div className="overflow-x-auto"><table className="table text-sm">
        <thead><tr><th>Código</th><th>Nombre</th><th>Tipo</th><th>Categoría</th><th className="text-right">Coste</th><th className="text-right">Precio lista</th><th>Unidad</th><th>Va sobre Geotab</th><th>Plan Geotab habitual</th><th className="text-right">En uso</th><th>Estado</th><th></th></tr></thead>
        <tbody>
          {loading&&<tr><td colSpan={12} className="text-center py-10 text-slate-400">Cargando…</td></tr>}
          {!loading&&filtrados.map(p=>{const n=enUso[p.id]||0;return <tr key={p.id} data-testid={`catalogo-fila-${p.sku}`} className={p.activo===false?'bg-slate-50 text-slate-500':''}>
            <td className="font-mono text-xs">{p.sku}</td>
            <td className="font-semibold">{p.nombre}</td>
            <td className="uppercase text-xs">{p.tipo}</td>
            <td>{p.categoria||'—'}</td>
            <td className="text-right tabular-nums">{Number(p.coste??0).toFixed(2)} €</td>
            <td className="text-right tabular-nums">{Number(p.precio??0).toFixed(2)} €</td>
            <td>{p.unidad||'ud'}</td>
            <td data-testid={`catalogo-vsg-${p.sku}`}>{p.tipo!=='saas'?'—':(p.va_sobre_geotab===false
              ? <span className="text-xs px-2 py-0.5 rounded bg-sky-100 text-sky-800 font-bold">No · servicio</span>
              : <span className="text-xs text-slate-600">Sí</span>)}</td>
            <td>{(p.tipo==='saas'&&p.va_sobre_geotab!==false)?(p.plan_geotab_habitual||<span className="text-amber-700">Sin plan</span>):'—'}</td>
            <td className="text-right tabular-nums">{n>0
              ? <a className="underline font-bold" data-testid={`catalogo-enuso-${p.sku}`} href={`/admin/saas/suscripciones?producto_saas_id=${p.id}`}>{n}</a>
              : <span className="text-slate-400">0</span>}</td>
            <td>{p.activo===false?<span className="text-xs px-2 py-0.5 rounded bg-slate-200">Retirado</span>:<span className="text-xs px-2 py-0.5 rounded bg-emerald-100 text-emerald-800 font-bold">Activo</span>}</td>
            <td className="flex gap-1">
              <button data-testid={`btn-catalogo-editar-${p.sku}`} className="p-1.5 rounded hover:bg-slate-100" title="Editar" onClick={()=>setEdit({...p})}><Pencil className="w-4 h-4"/></button>
              <button data-testid={`btn-catalogo-estado-${p.sku}`} className="text-xs px-2 py-1 rounded border font-semibold hover:bg-slate-50" onClick={()=>setRetirar({...p,_enUso:n})}>{p.activo===false?'Reactivar':'Retirar'}</button>
            </td>
          </tr>;})}
          {!loading&&!filtrados.length&&<tr><td colSpan={12} className="text-center py-10 text-slate-400">Sin productos con estos filtros.</td></tr>}
        </tbody></table></div>
    </div>
    {edit&&<ProductoModal value={edit} planes={planes} enUso={edit.id?(enUso[edit.id]||0):0} onClose={()=>setEdit(null)} onSave={guardar}/>}
    {retirar&&<RetirarModal value={retirar} onClose={()=>setRetirar(null)} onConfirm={cambiarEstado}/>}
  </div>;
}

function ProductoModal({value,planes,enUso,onClose,onSave}){
  const [f,setF]=useState(value);
  const set=(k,v)=>setF(x=>({...x,[k]:v}));
  const bloqueado=enUso>0;
  return <Modal title={f.id?`Editar · ${f.sku}`:'Nuevo producto'} onClose={onClose}>
    <div className="grid md:grid-cols-2 gap-4" data-testid="modal-producto">
      <Field label={`Código (SKU)${bloqueado?' · en uso, no editable':''}`}>
        <input data-testid="prod-sku" className="input" value={f.sku||''} disabled={bloqueado} onChange={e=>set('sku',e.target.value)}/></Field>
      <Field label="Nombre"><input data-testid="prod-nombre" className="input" value={f.nombre||''} onChange={e=>set('nombre',e.target.value)}/></Field>
      <Field label={`Tipo${bloqueado?' · en uso, no editable':''}`}>
        <select data-testid="prod-tipo" className="input" value={f.tipo||'saas'} disabled={bloqueado} onChange={e=>set('tipo',e.target.value)}>
          {TIPOS_PROD.map(([v,l])=><option key={v} value={v}>{l}</option>)}</select></Field>
      <Field label="Categoría"><input data-testid="prod-categoria" className="input" value={f.categoria||''} onChange={e=>set('categoria',e.target.value)}/></Field>
      <Field label="Coste (€)"><input data-testid="prod-coste" type="number" step="0.01" className="input" value={f.coste??0} onChange={e=>set('coste',e.target.value)}/></Field>
      <Field label="Precio de lista (€)"><input data-testid="prod-precio" type="number" step="0.01" className="input" value={f.precio??0} onChange={e=>set('precio',e.target.value)}/></Field>
      <Field label="Unidad"><select data-testid="prod-unidad" className="input" value={f.unidad||'ud'} onChange={e=>set('unidad',e.target.value)}>
        <option value="ud">ud</option><option value="mes">mes</option><option value="año">año</option></select></Field>
      {f.tipo==='saas'&&<Field label={`Va sobre Geotab${bloqueado?' · en uso, no editable':''}`}>
        <select data-testid="prod-va-sobre-geotab" className="input" disabled={bloqueado}
                value={f.va_sobre_geotab===false?'no':'si'}
                onChange={e=>set('va_sobre_geotab',e.target.value==='si')}>
          <option value="si">Sí · se apoya en un equipo Geotab</option>
          <option value="no">No · servicio sobre el equipo (hotline y similares)</option>
        </select></Field>}
      {f.tipo==='saas'&&f.va_sobre_geotab===false&&<div className="md:col-span-2 text-xs bg-sky-50 border border-sky-200 rounded-lg p-3 text-sky-900" data-testid="prod-aviso-servicio">
        Este producto NO exige plan Geotab y se da de alta desde la ficha de la suscripción principal del equipo («Añadir servicio»).
      </div>}
      {f.tipo==='saas'&&f.va_sobre_geotab!==false&&<Field label="Plan Geotab habitual">
        <select data-testid="prod-plan-geotab" className="input" value={f.plan_geotab_habitual||''} onChange={e=>set('plan_geotab_habitual',e.target.value)}>
          <option value="">Sin plan habitual</option>
          {/* Iter52.59 · 2 · el endpoint devuelve `codigo_plan` + `coste_mensual`;
              antes se leía pl.codigo/pl.plan/pl.nombre y salía en blanco. */}
          {planes.map(pl=>{const cod=pl.codigo_plan||pl.codigo||pl.plan||pl.nombre;
            const coste=pl.coste_mensual??pl.coste;
            return <option key={cod} value={cod}>{cod}{coste!=null?` · ${Number(coste).toFixed(2)} €`:''}</option>;})}
        </select></Field>}
      {bloqueado&&<div className="md:col-span-2 text-xs bg-amber-50 border border-amber-200 rounded-lg p-3 text-amber-900" data-testid="prod-aviso-en-uso">
        Producto en uso por <b>{enUso}</b> suscripciones: el código, el tipo y «Va sobre Geotab» no se pueden cambiar. El resto de campos sí.
      </div>}
    </div>
    <div className="flex gap-2 justify-end mt-5">
      <button className="btn-secondary" onClick={onClose}>Cancelar</button>
      <button data-testid="btn-prod-guardar" className="btn-primary" onClick={()=>onSave(f)} disabled={!f.sku||!f.nombre}>Guardar</button>
    </div>
  </Modal>;
}

function RetirarModal({value,onClose,onConfirm}){
  const [motivo,setMotivo]=useState('');
  const retirando=value.activo!==false;
  return <Modal title={`${retirando?'Retirar':'Reactivar'} · ${value.sku}`} onClose={onClose}>
    <div className="space-y-4 text-sm" data-testid="modal-retirar-producto">
      <div className="text-xs bg-slate-50 border rounded-lg p-3">
        {retirando
          ? <>Retirar <b>no borra nada</b>: el producto deja de admitir altas nuevas y lo que ya está vivo sigue facturando con normalidad.</>
          : <>Reactivar vuelve a permitir altas con este producto.</>}
        <div className="mt-2">En uso ahora: <b data-testid="retirar-en-uso">{value._enUso||0}</b> suscripciones vivas.</div>
      </div>
      <Field label="Motivo (obligatorio)"><input data-testid="retirar-motivo" className="input" value={motivo} onChange={e=>setMotivo(e.target.value)} placeholder="p. ej. producto descatalogado por el proveedor"/></Field>
      <div className="flex gap-2 justify-end">
        <button className="btn-secondary" onClick={onClose}>Cancelar</button>
        <button data-testid="btn-retirar-confirmar" className={retirando?'btn-danger':'btn-primary'} onClick={()=>onConfirm(value,motivo.trim())} disabled={!motivo.trim()}>{retirando?'Retirar':'Reactivar'}</button>
      </div>
    </div>
  </Modal>;
}

function RecuperarIdsGeotab(){
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(false);
  const [aplicando,setAplicando]=useState(false);
  const cargar=async()=>{
    setLoading(true);
    try{ const r=await saasApi.get('/saas/admin/ids-geotab-perdidos/preview'); setData(r.data); }
    catch(e){ toast.error(errText(e)); }
    finally{ setLoading(false); }
  };
  useEffect(()=>{cargar();/* eslint-disable-next-line */},[]);
  const aplicar=async()=>{
    setAplicando(true);
    try{
      const r=await saasApi.post('/saas/admin/ids-geotab-perdidos/aplicar');
      toast.success(`${r.data.aplicados} IDs recuperados${r.data.omitidos_por_conflicto?` · ${r.data.omitidos_por_conflicto} omitidos por conflicto`:''}`);
      cargar();
    }catch(e){ toast.error(errText(e)); }
    finally{ setAplicando(false); }
  };
  return <div className="bg-white border rounded-2xl p-5" data-testid="recuperar-ids-geotab">
    <div className="flex items-center justify-between mb-3 gap-3 flex-wrap">
      <div>
        <h2 className="text-xl font-black flex items-center gap-2"><Search className="w-5 h-5 text-emerald-600"/>Recuperar ID Geotab guardado en el sitio equivocado</h2>
        <p className="text-sm text-slate-500 mt-1">Altas antiguas guardaron el ID en un campo que no lee ninguna pantalla. Aquí se copia a su sitio (ID Geotab), solo en los equipos sin conflicto. Nada se escribe hasta que pulses «Aplicar».</p>
      </div>
      <button className="btn-secondary" onClick={cargar} disabled={loading} data-testid="btn-ids-perdidos-refrescar">{loading?'Buscando…':'Volver a buscar'}</button>
    </div>
    {data && <>
      <div className="grid sm:grid-cols-3 gap-3">
        <div className="border rounded-xl p-3"><p className="text-xs uppercase text-slate-500">Equipos afectados</p><p className="text-2xl font-black" data-testid="ids-perdidos-total">{data.total}</p></div>
        <div className="border rounded-xl p-3 bg-emerald-50 border-emerald-300"><p className="text-xs uppercase text-slate-500">Se pueden recuperar</p><p className="text-2xl font-black text-emerald-700" data-testid="ids-perdidos-recuperables">{data.recuperables}</p></div>
        <div className={`border rounded-xl p-3 ${data.con_conflicto?'bg-amber-50 border-amber-300':''}`}><p className="text-xs uppercase text-slate-500">Con conflicto (otro equipo usa ese ID)</p><p className="text-2xl font-black text-amber-700" data-testid="ids-perdidos-conflicto">{data.con_conflicto}</p></div>
      </div>
      {data.total===0
        ? <p className="text-sm text-emerald-700 font-semibold mt-4" data-testid="ids-perdidos-vacio">No hay ningún equipo con el ID guardado en el sitio equivocado.</p>
        : <>
          <div className="overflow-x-auto mt-4 max-h-80">
            <table className="table text-xs">
              <thead><tr><th>Cliente</th><th>Matrícula</th><th>Estado</th><th>ID a recuperar</th><th>Conflicto</th></tr></thead>
              <tbody>{data.items.map(x=><tr key={x.dispositivo_id} data-testid={`ids-perdidos-fila-${x.dispositivo_id}`}>
                <td>{x.cliente||'—'}</td><td>{x.matricula||'—'}</td>
                <td>{x.estado_dispositivo}{x.estado_suscripcion?` · ${x.estado_suscripcion}`:''}</td>
                <td className="font-mono">{x.valor}</td>
                <td>{x.conflicto?<span className="text-amber-700 font-bold">lo usa {x.conflicto_con?.matricula||x.conflicto_con?.dispositivo_id}</span>:<span className="text-emerald-700">—</span>}</td>
              </tr>)}</tbody>
            </table>
          </div>
          <div className="flex justify-end mt-3">
            <button className="btn-primary" onClick={aplicar} disabled={aplicando||!data.recuperables} data-testid="btn-ids-perdidos-aplicar">
              {aplicando?'Aplicando…':`Aplicar a los ${data.recuperables} sin conflicto`}
            </button>
          </div>
        </>}
    </>}
  </div>;
}

function Ajustes(){
  return <div className="space-y-4" data-testid="ajustes">
    <ReconciliarGrupos/>
    <NormalizarPrepago/>
    <RecuperarIdsGeotab/>
    <DiagnosticoTipos/>
  </div>;
}

// ============================================================================
// Iter52.11 · Ajustes Preview (super_admin, sólo Preview) · acciones que
// NUNCA deben existir en producción. Sólo Borrar. La importación sigue
// viviendo en la pestaña "Importación inicial" existente (sin duplicar).
// ============================================================================
function AjustesPreview(){
  const [estado,setEstado]=useState(null);
  const [loading,setLoading]=useState(false);
  const cargar=async()=>{
    setLoading(true);
    try{const r=await saasApi.get('/saas/admin/ajustes-preview/estado');setEstado(r.data);}
    catch(e){toast.error(errText(e));}
    finally{setLoading(false);}
  };
  useEffect(()=>{cargar();/* eslint-disable-next-line */},[]);
  const esProd = estado && !estado.es_preview;
  return <div className="space-y-6" data-testid="ajustes-preview">
    <div className={`border-2 rounded-2xl p-4 flex items-center gap-3 ${esProd?'bg-rose-50 border-rose-400':'bg-emerald-50 border-emerald-400'}`}>
      <Database className={`w-8 h-8 ${esProd?'text-rose-700':'text-emerald-700'}`}/>
      <div className="flex-1">
        {estado
          ? <><p className={`font-black ${esProd?'text-rose-900':'text-emerald-900'}`}>Entorno detectado: <span className="uppercase">{estado.kind}</span></p>
              <p className={`text-xs ${esProd?'text-rose-800':'text-emerald-800'}`}>MongoDB: <code>{estado.mongo_host_seguro}</code> · {estado.total} documentos en colecciones SaaS</p>
              {esProd && <p className="text-xs text-rose-900 font-bold mt-1">⚠ Acciones destructivas bloqueadas por diseño en este entorno.</p>}
            </>
          : <p className="text-slate-500">Detectando entorno…</p>}
      </div>
      <button className="btn-secondary text-xs" onClick={cargar} disabled={loading}>{loading?'Cargando…':'Refrescar'}</button>
    </div>

    <BorrarPreviewSection estado={estado} onCambio={cargar}/>

    <p className="text-xs text-slate-500 border-l-4 border-slate-300 pl-3">
      Para poblar Preview tras borrar, usa la pestaña <b>Importación inicial</b> con el MAESTRO ofuscado (subida sobre limpio, sin reconciliar). El botón <b>"Descargar MAESTRO histórico"</b> — para bajar de Producción un XLSX en el formato del importador — vive ahora en la pestaña <b>Control</b> · menú "Más opciones".
    </p>
  </div>;
}



function BorrarPreviewSection({estado, onCambio}){
  const [confirm,setConfirm]=useState('');
  const [busy,setBusy]=useState(false);
  const [result,setResult]=useState(null);
  const bloqueado = !estado || !estado.es_preview;
  const habilitado = estado && estado.es_preview && confirm.trim()==='BORRAR' && !busy;
  const ejecutar=async()=>{
    if(!habilitado)return;
    setBusy(true);setResult(null);
    try{
      const r=await saasApi.post('/saas/admin/ajustes-preview/borrar',{confirmacion:'BORRAR'});
      setResult(r.data);toast.success(`${r.data.total_borrados} documentos borrados`);setConfirm('');
      onCambio && onCambio();
    }catch(e){toast.error(errText(e));}
    finally{setBusy(false);}
  };
  return <div className="bg-white border rounded-2xl p-5" data-testid="ajustes-preview-borrar">
    <div className="flex items-start gap-3 mb-3">
      <Trash2 className="w-5 h-5 text-rose-600 mt-1"/>
      <div className="flex-1">
        <h2 className="text-lg font-black">Borrar datos SaaS de Preview</h2>
        <p className="text-sm text-slate-600 mt-1">Vacía las colecciones del módulo Operaciones SaaS (todas las <code>saas_*</code> + <code>clientes_operativos</code>). Úsalo antes de importar el MAESTRO para arrancar desde cero, o al terminar para dejar Preview limpio.</p>
        <p className="text-xs text-rose-700 font-bold mt-1">Irreversible. Sólo aplica al entorno actual · imposible ejecutar contra producción por diseño.</p>
      </div>
    </div>
    {estado?.colecciones && <details className="mt-2 text-xs text-slate-600"><summary className="cursor-pointer font-semibold">Ver colecciones y counts actuales</summary>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-1 mt-2 font-mono">
        {estado.colecciones.map(c=><div key={c.nombre} className={`px-2 py-1 rounded ${c.count>0?'bg-amber-50':'bg-slate-50'}`}>{c.nombre}: <b>{c.count}</b></div>)}
      </div>
    </details>}
    <div className="flex items-center gap-3 mt-3">
      <input data-testid="input-confirmar-borrar" type="text" className="input" placeholder='Escribe "BORRAR" para confirmar' value={confirm} onChange={e=>setConfirm(e.target.value)} disabled={bloqueado||busy}/>
      <button data-testid="btn-ejecutar-borrar" className={`px-4 py-2 rounded-lg font-bold text-white ${habilitado?'bg-rose-600 hover:bg-rose-700':'bg-slate-300 cursor-not-allowed'}`} onClick={ejecutar} disabled={!habilitado}>{busy?'Borrando…':'Borrar Preview'}</button>
    </div>
    {result && <div className="mt-3 text-sm bg-slate-50 border rounded-lg p-3" data-testid="borrar-resultado">
      <p className="font-bold text-emerald-700">✓ {result.total_borrados} documentos borrados</p>
      <details className="text-xs text-slate-600 mt-1"><summary className="cursor-pointer">Detalle por colección</summary><ul className="mt-1 font-mono">{result.resultado.map((r,i)=><li key={i}>{r.coleccion}: {r.borrados}{r.error?` · ERROR: ${r.error}`:''}</li>)}</ul></details>
    </div>}
  </div>;
}





const clean=(obj)=>Object.fromEntries(Object.entries(obj).filter(([k])=>!['_id','created_at','updated_at','created_by','updated_by','resumen'].includes(k)));
function Box({title,onAdd,children}){return <div className="bg-white border rounded-2xl p-5"><div className="flex justify-between mb-4"><h2 className="text-xl font-black">{title}</h2><button className="btn-primary" onClick={onAdd}><Plus className="w-4 h-4"/>Nuevo</button></div>{children}</div>}
function Simple({headers,rows}){return <div className="overflow-auto"><table className="table"><thead><tr>{headers.map(h=><th key={h}>{h}</th>)}</tr></thead><tbody>{rows.length?rows.map((r,i)=><tr key={i}>{r.map((c,j)=><td key={j}>{c}</td>)}</tr>):<tr><td colSpan={headers.length} className="text-center py-8 text-slate-400">Sin resultados</td></tr>}</tbody></table></div>}
function Field({label,children}){return <label className="block mb-3"><span className="text-xs font-bold text-slate-600 block mb-1.5">{label}</span>{children}</label>}
function Modal({title,onClose,children}){return <div className="fixed inset-0 bg-black/35 z-50 flex items-center justify-center p-4"><div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-auto"><div className="p-5 border-b flex justify-between sticky top-0 bg-white"><h2 className="font-black text-xl">{title}</h2><button onClick={onClose}><X className="w-5 h-5"/></button></div><div className="p-5">{children}</div></div></div>}

// ============================================================================
// Iter52.13 · Catálogo Geotab (super_admin) · CSV rate plans + product pricing.
// Histórico + informe de diferencias + actualización de coste en suscripciones.
// ============================================================================
function CatalogoGeotab(){
  const [planes,setPlanes]=useState([]);
  const [productos,setProductos]=useState([]);
  const [versiones,setVersiones]=useState({planes:[],productos:[]});
  const [diffAbierto,setDiffAbierto]=useState(null);
  // Iter52.62 · B6 · ref_id de versión → id del informe PDF guardado.
  const [informes,setInformes]=useState({});

  const cargar=async()=>{
    try{
      const [p,pr,vp,vh,inf]=await Promise.all([
        saasApi.get('/saas/admin/catalogo-geotab/planes'),
        saasApi.get('/saas/admin/catalogo-geotab/productos'),
        saasApi.get('/saas/admin/catalogo-geotab/versiones?tipo=planes'),
        saasApi.get('/saas/admin/catalogo-geotab/versiones?tipo=productos'),
        saasApi.get('/saas/informes-carga?limit=200').catch(()=>({data:{items:[]}})),
      ]);
      setPlanes(p.data.items||[]);
      setProductos(pr.data.items||[]);
      setVersiones({planes:vp.data.items||[],productos:vh.data.items||[]});
      const mapa={};(inf.data.items||[]).forEach(x=>{if(x.ref_id&&!mapa[x.ref_id])mapa[x.ref_id]=x.id;});
      setInformes(mapa);
    }catch(e){toast.error(errText(e));}
  };
  useEffect(()=>{cargar();/* eslint-disable-next-line */},[]);

  const abrirDiff=async(vid)=>{
    try{const r=await saasApi.get(`/saas/admin/catalogo-geotab/versiones/${vid}/diff`);setDiffAbierto(r.data);}
    catch(e){toast.error(errText(e));}
  };

  return <div className="space-y-8" data-testid="catalogo-geotab">
    <div className="bg-emerald-50 border-l-4 border-emerald-500 rounded-lg p-3 text-sm text-emerald-900">
      El coste de las suscripciones (<code>coste_geotab_actual</code>) se puebla desde este catálogo, no desde el maestro. Sube el CSV de Geotab, revisa el informe de diferencias y ejecuta <b>"Actualizar coste desde catálogo"</b>. Sólo super_admin.
    </div>

    <CargaCsvSection tipo="planes" endpoint="/saas/admin/catalogo-geotab/planes" onDone={cargar} onDiff={setDiffAbierto}/>
    {/* Iter52.20 · "Aplicar coste desde catálogo" se sube justo debajo
        de la carga (antes estaba oculto al final) para que la acción de
        propagar el coste sea inmediatamente visible tras aplicar el CSV. */}
    <ActualizarCostesSection/>
    <PlanesTable items={planes}/>
    <VersionesList items={versiones.planes} onOpen={abrirDiff} label="Planes" informes={informes}/>

    <hr className="my-6"/>

    <CargaCsvSection tipo="productos" endpoint="/saas/admin/catalogo-geotab/productos" onDone={cargar} onDiff={setDiffAbierto}/>
    <ProductosTable items={productos}/>
    <VersionesList items={versiones.productos} onOpen={abrirDiff} label="Productos" informes={informes}/>

    {diffAbierto && <DiffModal data={diffAbierto} onClose={()=>setDiffAbierto(null)}/>}
  </div>;
}

function CargaCsvSection({tipo, endpoint, onDone, onDiff}){
  const {descargando,conEstadoDescarga}=useDescargas();
  const [file,setFile]=useState(null);
  const [preview,setPreview]=useState(null);
  const [busy,setBusy]=useState(false);
  // Iter52.62 · B6 · informe PDF generado al aplicar (descarga automática).
  const [informeId,setInformeId]=useState(null);
  // Iter52.63 · P2 · diff devuelto al aplicar (Product Pricing solo trae
  // contadores en la previsualización; el detalle llega al aplicar).
  const [diffAplicado,setDiffAplicado]=useState(null);
  const previsualizar=async()=>{
    if(!file){toast.error('Selecciona un CSV');return;}
    setBusy(true);
    try{
      const fd=new FormData();fd.append('csv_file',file);
      const r=await saasApi.post(`${endpoint}/preview`,fd,{headers:{'Content-Type':'multipart/form-data'}});
      setPreview(r.data);
    }catch(e){toast.error(errText(e));}finally{setBusy(false);}
  };
  const aplicar=async()=>{
    if(!preview?.token)return;
    setBusy(true);
    try{
      const r=await saasApi.post(`${endpoint}/aplicar`,{token:preview.token});
      toast.success(`Carga aplicada · versión ${r.data.version_id}`);
      setPreview(null);setFile(null);
      if(r.data.diff) setDiffAplicado(r.data.diff);
      if(r.data.informe_id){
        setInformeId(r.data.informe_id);
        descargarInformeCarga(r.data.informe_id,{silencioso:true});
      }
      onDone && onDone();
      if(r.data.diff){onDiff && onDiff({...r.data,diff:r.data.diff});}
    }catch(e){toast.error(errText(e));}finally{setBusy(false);}
  };
  const titulo = tipo==='planes' ? 'Rate Plans (planes SaaS)' : 'Product Pricing (HW)';
  // Iter52.63 · P2 · KPI pulsables: abren/filtran el detalle del preview.
  const [kpiAbierto,setKpiAbierto]=useState('');
  const diff = (preview && (preview.diff || preview.diff_productos)) || diffAplicado || null;
  const impactoTotal = (diff?.cambios_coste||[]).reduce((a,c)=>a+parseFloat(c.impacto_mes||0),0);
  const DETALLES = {
    nuevos: {titulo:'Planes nuevos', filas:(diff?.planes_nuevos||[]).map(c=>`${c.codigo_plan} · ${c.coste_nuevo} € · ${c.suscripciones_afectadas} suscripciones`)},
    cambios: {titulo:'Cambios de coste', filas:(diff?.cambios_coste||[]).map(c=>`${c.codigo_plan}: ${c.coste_anterior} → ${c.coste_nuevo} € · ${c.suscripciones_afectadas} suscripciones · impacto ${Number(c.impacto_mes||0).toFixed(2)} €/mes`)},
    conflictos: {titulo:'Conflictos (NO importados)', filas:(diff?.conflictos_tarifas||[]).map(c=>`${c.codigo_plan} · ${c.n_tarifas} tarifas · ${c.suscripciones_afectadas} suscripciones`)},
    desaparecidos: {titulo:'Desaparecidos', filas:(diff?.planes_desaparecidos||[]).map(c=>`${c.codigo_plan} · era ${c.coste_anterior} € · ${c.suscripciones_afectadas} suscripciones`)},
    conservados: {titulo:'Conservados (fuera de tarifa)', filas:(diff?.planes_conservados||[]).map(c=>`${c.codigo_plan} · ${c.coste_anterior} € · ${c.suscripciones_afectadas} suscripciones`)},
    prod_nuevos: {titulo:'Productos nuevos', filas:(diff?.nuevos||[]).map(p=>`${p.product_code} · ${p.descripcion||''} · ${p.partner_cost} € / MSRP ${p.msrp} €`)},
    prod_cambios: {titulo:'Cambios', filas:(diff?.cambios||[]).map(p=>`${p.product_code}: partner ${p.partner_cost_anterior} → ${p.partner_cost_nuevo} € · MSRP ${p.msrp_anterior} → ${p.msrp_nuevo} €`)},
    prod_quitados: {titulo:'Quitados', filas:(diff?.quitados||[]).map(p=>`${p.product_code} · era ${p.partner_cost} €`)},
  };
  const pasoActual = informeId ? 3 : preview ? 2 : file ? 1 : 0;
  return <SeccionPlegable titulo={`Cargar CSV · ${titulo}`} testid={`carga-csv-${tipo}`} contador={preview?'previsualizado':''}>
    <PasosCarga pasos={['Subir','Previsualizar','Aplicar','Descargar informe']} actual={pasoActual} testid={`pasos-${tipo}`}/>
    <p className="text-sm text-slate-600 my-3">La versión anterior queda en histórico (nunca se borra). {tipo==='planes'&&'Los planes con tarifas distintas en el CSV se registran en el informe pero NO se importan.'}</p>
    <div className="flex items-center gap-3">
      <input type="file" accept=".csv" data-testid={`file-${tipo}`} onChange={e=>{setFile(e.target.files?.[0]||null);setPreview(null);}} className="text-sm"/>
      {!preview
        ? <button className="btn-secondary" data-testid={`btn-preview-${tipo}`} onClick={previsualizar} disabled={busy||!file}>{busy?'Analizando…':'Previsualizar'}</button>
        : <button className="btn-primary" data-testid={`btn-aplicar-${tipo}`} onClick={aplicar} disabled={busy}>{busy?'Aplicando…':'Aplicar carga'}</button>}
      {informeId && <button className="link text-xs disabled:opacity-60 disabled:cursor-not-allowed" data-testid={`link-informe-${tipo}`} disabled={descargando('informe-pdf')}
        onClick={()=>conEstadoDescarga('informe-pdf',()=>descargarInformeCarga(informeId))}>{descargando('informe-pdf')?'Generando…':'Descargar informe (PDF)'}</button>}
    </div>
    {preview && tipo==='planes' && preview.diff && <>
      <div className="mt-3 grid grid-cols-2 md:grid-cols-6 gap-3 text-xs">
        <Metric label="Importables" value={preview.diff.resumen.planes_importables}/>
        <MetricBtn label="Nuevos" value={preview.diff.resumen.planes_nuevos} tone="emerald" activo={kpiAbierto==='nuevos'} onClick={()=>setKpiAbierto(k=>k==='nuevos'?'':'nuevos')} testid={`kpi-${tipo}-nuevos`}/>
        <MetricBtn label="Cambios coste" value={preview.diff.resumen.cambios_coste} tone={preview.diff.resumen.cambios_coste?'amber':'slate'} activo={kpiAbierto==='cambios'} onClick={()=>setKpiAbierto(k=>k==='cambios'?'':'cambios')} testid={`kpi-${tipo}-cambios`}/>
        <MetricBtn label="Conflictos (NO import.)" value={preview.diff.resumen.planes_en_conflicto_no_importados} tone={preview.diff.resumen.planes_en_conflicto_no_importados?'rose':'slate'} activo={kpiAbierto==='conflictos'} onClick={()=>setKpiAbierto(k=>k==='conflictos'?'':'conflictos')} testid={`kpi-${tipo}-conflictos`}/>
        <MetricBtn label="Desaparecidos" value={preview.diff.resumen.planes_desaparecidos} activo={kpiAbierto==='desaparecidos'} onClick={()=>setKpiAbierto(k=>k==='desaparecidos'?'':'desaparecidos')} testid={`kpi-${tipo}-desaparecidos`}/>
        <MetricBtn label="Conservados" value={preview.diff.resumen.planes_conservados} tone="sky" activo={kpiAbierto==='conservados'} onClick={()=>setKpiAbierto(k=>k==='conservados'?'':'conservados')} testid={`kpi-${tipo}-conservados`}/>
      </div>
      <div className="mt-3 grid grid-cols-2 md:grid-cols-2 gap-3 text-xs">
        <Metric label="Suscripc. impactadas" value={preview.diff.resumen.suscripciones_impactadas_por_cambio}/>
        <Metric label="Impacto total €/mes" value={`${impactoTotal.toFixed(2)} €`} tone={impactoTotal?'amber':'slate'} testid={`kpi-${tipo}-impacto-total`}/>
      </div>
    </>}
    {preview && tipo==='productos' && <div className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-3 text-xs">
      <Metric label="Totales" value={preview.resumen?.productos_totales}/>
      <MetricBtn label="Nuevos" value={preview.resumen?.productos_nuevos} tone={preview.resumen?.productos_nuevos?'emerald':'slate'} activo={kpiAbierto==='prod_nuevos'} onClick={()=>setKpiAbierto(k=>k==='prod_nuevos'?'':'prod_nuevos')} testid={`kpi-${tipo}-nuevos`}/>
      <MetricBtn label="Cambios de precio" value={preview.resumen?.productos_con_cambios} tone={preview.resumen?.productos_con_cambios?'amber':'slate'} activo={kpiAbierto==='prod_cambios'} onClick={()=>setKpiAbierto(k=>k==='prod_cambios'?'':'prod_cambios')} testid={`kpi-${tipo}-cambios`}/>
      <Metric label="Sin cambios" value={preview.resumen?.productos_sin_cambios}/>
    </div>}
    {/* Iter52.63 · P2 · Product Pricing: listado de nuevos/cambios/quitados
        tras aplicar (antes solo había contadores). */}
    {tipo==='productos' && diffAplicado && <div className="mt-3 grid grid-cols-2 md:grid-cols-3 gap-3 text-xs">
      <MetricBtn label="Nuevos" value={(diffAplicado.nuevos||[]).length} tone="emerald" activo={kpiAbierto==='prod_nuevos'} onClick={()=>setKpiAbierto(k=>k==='prod_nuevos'?'':'prod_nuevos')} testid="kpi-aplicado-nuevos"/>
      <MetricBtn label="Cambios" value={(diffAplicado.cambios||[]).length} tone="amber" activo={kpiAbierto==='prod_cambios'} onClick={()=>setKpiAbierto(k=>k==='prod_cambios'?'':'prod_cambios')} testid="kpi-aplicado-cambios"/>
      <MetricBtn label="Quitados" value={(diffAplicado.quitados||[]).length} activo={kpiAbierto==='prod_quitados'} onClick={()=>setKpiAbierto(k=>k==='prod_quitados'?'':'prod_quitados')} testid="kpi-aplicado-quitados"/>
    </div>}
    {kpiAbierto && DETALLES[kpiAbierto] && <div className="mt-3 border rounded-lg bg-slate-50 p-3" data-testid={`detalle-${tipo}-${kpiAbierto}`}>
      <p className="text-xs font-bold mb-1">{DETALLES[kpiAbierto].titulo} · {DETALLES[kpiAbierto].filas.length}</p>
      {DETALLES[kpiAbierto].filas.length===0
        ? <p className="text-xs text-slate-400">El detalle completo aparece al aplicar la carga (y en el informe PDF).</p>
        : <ul className="max-h-56 overflow-auto text-[11px] font-mono space-y-0.5">{DETALLES[kpiAbierto].filas.map((t,i)=><li key={i}>{t}</li>)}</ul>}
    </div>}
  </SeccionPlegable>;
}

// Iter52.63 · P2 · Sección plegable reutilizable (plegada por defecto).
function SeccionPlegable({titulo,contador,testid,children,abiertaInicial=false}){
  const [abierta,setAbierta]=useState(abiertaInicial);
  return <div className="bg-white border rounded-2xl" data-testid={testid}>
    <button type="button" onClick={()=>setAbierta(a=>!a)} data-testid={`${testid}-toggle`}
            className="w-full flex items-center gap-2 px-5 py-3 text-left">
      {abierta?<ChevronDown className="w-4 h-4 text-slate-400"/>:<ChevronRight className="w-4 h-4 text-slate-400"/>}
      <h2 className="text-lg font-black">{titulo}</h2>
      {contador!==''&&contador!==undefined&&<span className="text-xs text-slate-500 ml-auto">{contador}</span>}
    </button>
    {abierta && <div className="px-5 pb-5">{children}</div>}
  </div>;
}

// Iter52.63 · P2 · KPI pulsable.
function MetricBtn({label,value,tone='slate',activo,onClick,testid}){
  const cls = {slate:'bg-slate-50 border-slate-200',amber:'bg-amber-50 border-amber-300',rose:'bg-rose-50 border-rose-300',emerald:'bg-emerald-50 border-emerald-300',sky:'bg-sky-50 border-sky-300'}[tone];
  return <button type="button" onClick={onClick} data-testid={testid}
    className={`border rounded-lg p-2 text-left hover:brightness-95 ${cls} ${activo?'ring-2 ring-indigo-400':''}`}>
    <p className="text-[10px] uppercase font-bold text-slate-500">{label}</p>
    <p className="text-lg font-black">{value ?? 0}</p>
  </button>;
}

function Metric({label,value,tone='slate',testid}){
  const cls = {slate:'bg-slate-50 border-slate-200',amber:'bg-amber-50 border-amber-300',rose:'bg-rose-50 border-rose-300',emerald:'bg-emerald-50 border-emerald-300',sky:'bg-sky-50 border-sky-300'}[tone];
  return <div className={`border rounded-lg p-2 ${cls}`} data-testid={testid}><p className="text-[10px] uppercase font-bold text-slate-500">{label}</p><p className="text-lg font-black">{value}</p></div>;
}

function PlanesTable({items}){
  const [orden,setOrden]=useState({col:'suscripciones_afectadas',dir:'desc'});
  const sorted = useMemo(()=>{
    const arr=[...items];
    arr.sort((a,b)=>{
      const av=a[orden.col],bv=b[orden.col];
      if(typeof av==='number'&&typeof bv==='number')return orden.dir==='desc'?bv-av:av-bv;
      const sa=String(av||''),sb=String(bv||'');
      return orden.dir==='desc'?sb.localeCompare(sa):sa.localeCompare(sb);
    });
    return arr;
  },[items,orden]);
  const th=(col,label)=><th className="cursor-pointer hover:bg-slate-100" onClick={()=>setOrden(o=>({col,dir:o.col===col&&o.dir==='desc'?'asc':'desc'}))}>{label} {orden.col===col?(orden.dir==='desc'?'↓':'↑'):''}</th>;
  return <SeccionPlegable titulo={`Planes vigentes · ${items.length}`} testid="tabla-planes-geotab" contador="">
    <div className="overflow-x-auto"><table className="table">
      <thead><tr>{th('codigo_plan','Código plan')}{th('coste_mensual','€/mes')}{th('suscripciones_afectadas','Suscripciones')}</tr></thead>
      <tbody>{sorted.length?sorted.map((p,i)=><tr key={i}><td className="font-mono text-xs">{p.codigo_plan}{p.fuera_de_tarifa&&<span className="ml-2 px-1.5 py-0.5 rounded bg-sky-100 text-sky-800 text-[10px] font-bold uppercase" data-testid={`badge-fuera-tarifa-${i}`}>fuera de tarifa</span>}</td><td className="tabular-nums">{p.coste_mensual} €</td><td className="tabular-nums">{p.suscripciones_afectadas}</td></tr>):<tr><td colSpan={3} className="text-center text-slate-400 py-6">Sin catálogo cargado.</td></tr>}</tbody>
    </table></div>
  </SeccionPlegable>;
}

function ProductosTable({items}){
  const [orden,setOrden]=useState({col:'product_code',dir:'asc'});
  const sorted = useMemo(()=>{
    const arr=[...items];
    arr.sort((a,b)=>{const sa=String(a[orden.col]||''),sb=String(b[orden.col]||'');return orden.dir==='desc'?sb.localeCompare(sa):sa.localeCompare(sb);});
    return arr;
  },[items,orden]);
  const th=(col,label)=><th className="cursor-pointer hover:bg-slate-100" onClick={()=>setOrden(o=>({col,dir:o.col===col&&o.dir==='asc'?'desc':'asc'}))}>{label} {orden.col===col?(orden.dir==='desc'?'↓':'↑'):''}</th>;
  return <SeccionPlegable titulo={`Productos HW vigentes · ${items.length}`} testid="tabla-productos-geotab" contador="">
    <div className="overflow-x-auto"><table className="table">
      <thead><tr>{th('product_code','Product code')}{th('descripcion','Descripción')}{th('category','Categoría')}{th('partner_cost','Partner cost')}{th('msrp','MSRP')}</tr></thead>
      <tbody>{sorted.length?sorted.map((p,i)=><tr key={i}><td className="font-mono text-xs">{p.product_code}</td><td className="text-xs max-w-md truncate" title={p.descripcion}>{p.descripcion}</td><td className="text-xs">{p.category}</td><td className="tabular-nums">{p.partner_cost} €</td><td className="tabular-nums">{p.msrp} €</td></tr>):<tr><td colSpan={5} className="text-center text-slate-400 py-6">Sin productos cargados.</td></tr>}</tbody>
    </table></div>
  </SeccionPlegable>;
}

function VersionesList({items,onOpen,label,informes={}}){
  const {descargando,conEstadoDescarga}=useDescargas();
  if(!items.length)return null;
  return <details className="bg-white border rounded-2xl p-4 text-sm" data-testid={`historico-${label}`}>
    <summary className="cursor-pointer font-bold">Histórico de cargas · {label} ({items.length})</summary>
    <ul className="mt-2 divide-y">
      {items.map((v,i)=><li key={i} className="py-2 flex items-center justify-between gap-3">
        <div><p className="font-mono text-xs">{v.filename}</p><p className="text-xs text-slate-500">{v.uploaded_at?new Date(v.uploaded_at).toLocaleString('es-ES'):''} · {v.uploaded_by}</p></div>
        <div className="flex items-center gap-3">
          {informes[v.id] && <button className="link text-xs disabled:opacity-60 disabled:cursor-not-allowed" data-testid={`btn-pdf-version-${v.id}`} disabled={descargando(`pdf-${v.id}`)}
            onClick={()=>conEstadoDescarga(`pdf-${v.id}`,()=>descargarInformeCarga(informes[v.id]))}>{descargando(`pdf-${v.id}`)?'Generando…':'PDF'}</button>}
          <button className="link text-xs" onClick={()=>onOpen(v.id)}>Ver diff →</button>
        </div>
      </li>)}
    </ul>
  </details>;
}

function DiffModal({data,onClose}){
  const diff = data.diff || {};
  return <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-auto">
      <div className="p-5 border-b flex justify-between items-center sticky top-0 bg-white">
        <div><h3 className="font-black">Informe de diferencias</h3><p className="text-xs text-slate-500 font-mono">{data.filename||data.id}</p></div>
        <button onClick={onClose}><X className="w-5 h-5"/></button>
      </div>
      <div className="p-5 space-y-4 text-sm">
        {diff.conflictos_tarifas?.length>0 && <Section title={`Conflictos · ${diff.conflictos_tarifas.length} (NO importados)`} tone="rose">
          {diff.conflictos_tarifas.map((c,i)=><div key={i} className="border-l-4 border-rose-400 pl-3 py-2">
            <p><b className="font-mono">{c.codigo_plan}</b> · {c.n_tarifas} tarifas distintas · {c.suscripciones_afectadas} suscripciones</p>
            <ul className="text-xs text-slate-600 mt-1">{c.variantes.map((v,j)=><li key={j}>· fila {v.fila_csv}: <b>{v.coste} €</b> — <code className="text-[11px]">{v.codigo_literal}</code></li>)}</ul>
          </div>)}
        </Section>}
        {diff.cambios_coste?.length>0 && <Section title={`Cambios de coste · ${diff.cambios_coste.length}`} tone="amber">
          {diff.cambios_coste.map((c,i)=><p key={i} className="border-l-4 border-amber-400 pl-3 py-1 font-mono text-xs">{c.codigo_plan}: <b>{c.coste_anterior}</b> → <b>{c.coste_nuevo}</b> € · {c.suscripciones_afectadas} suscripciones{c.impacto_mes!==undefined&&<> · impacto <b>{Number(c.impacto_mes||0).toFixed(2)} €/mes</b></>}</p>)}
        </Section>}
        {diff.planes_nuevos?.length>0 && <Section title={`Planes nuevos · ${diff.planes_nuevos.length}`} tone="emerald">
          {diff.planes_nuevos.map((c,i)=><p key={i} className="font-mono text-xs">{c.codigo_plan} · {c.coste_nuevo} € · {c.suscripciones_afectadas} suscripciones</p>)}
        </Section>}
        {diff.planes_conservados?.length>0 && <Section title={`Conservados (fuera de tarifa) · ${diff.planes_conservados.length}`} tone="sky">
          <p className="text-xs text-slate-600 mb-1">Geotab ya no los publica, pero los usan suscripciones vivas: siguen vigentes con su último coste.</p>
          {diff.planes_conservados.map((c,i)=><p key={i} className="font-mono text-xs" data-testid={`diff-conservado-${i}`}>{c.codigo_plan} · {c.coste_anterior} € · {c.suscripciones_afectadas} suscripciones</p>)}
        </Section>}
        {diff.planes_desaparecidos?.length>0 && <Section title={`Planes desaparecidos · ${diff.planes_desaparecidos.length}`} tone="slate">
          {diff.planes_desaparecidos.map((c,i)=><p key={i} className="font-mono text-xs">{c.codigo_plan} · era {c.coste_anterior} € · {c.suscripciones_afectadas} suscripciones</p>)}
        </Section>}
      </div>
    </div>
  </div>;
}

function Section({title,tone,children}){
  const bg={rose:'bg-rose-50',amber:'bg-amber-50',emerald:'bg-emerald-50',slate:'bg-slate-50',sky:'bg-sky-50'}[tone];
  return <div className={`rounded-lg p-3 ${bg}`}><h4 className="font-bold mb-2">{title}</h4><div className="space-y-1">{children}</div></div>;
}

function ActualizarCostesSection(){
  const [busy,setBusy]=useState(false);
  const [dry,setDry]=useState(null);
  const [result,setResult]=useState(null);
  const previsualizar=async()=>{
    setBusy(true);setResult(null);
    try{
      const r=await saasApi.post('/saas/admin/catalogo-geotab/actualizar-costes',{dry_run:true});
      setDry(r.data);
    }catch(e){toast.error(errText(e));}finally{setBusy(false);}
  };
  const aplicar=async()=>{
    if(!dry)return;
    if(!window.confirm(`¿Aplicar coste del catálogo? Se actualizarán ${dry.actualizadas} suscripciones (coste diferente) y se sellará el origen en ${dry.sellado_origen||0} más (coste ya correcto pero sin sello). ${dry.sin_casar} quedarán como incidencia SIN_COSTE_DE_CATALOGO.`))return;
    setBusy(true);
    try{
      const r=await saasApi.post('/saas/admin/catalogo-geotab/actualizar-costes',{dry_run:false});
      setResult(r.data);setDry(null);
      toast.success(`${r.data.actualizadas} suscripciones actualizadas`);
    }catch(e){toast.error(errText(e));}finally{setBusy(false);}
  };
  return <div className="bg-white border-2 border-sky-400 rounded-2xl p-5" data-testid="actualizar-costes-suscripciones">
    <h2 className="text-lg font-black mb-2">Actualizar coste de suscripciones desde catálogo</h2>
    <p className="text-sm text-slate-600 mb-3">Por cada suscripción, busca su <code>plan_geotab_codigo_origen</code> en el catálogo vigente y escribe el <code>coste_mensual</code> como nuevo <code>coste_geotab_actual</code>. Las que no casan no se tocan y salen en Control como <b>SIN_COSTE_DE_CATALOGO</b>. Puedes lanzarlo tras cada carga mensual.</p>
    <div className="flex items-center gap-3">
      {!dry
        ? <button className="btn-secondary" data-testid="btn-preview-actualizar" onClick={previsualizar} disabled={busy}>{busy?'Analizando…':'Previsualizar'}</button>
        : <button className="btn-primary" data-testid="btn-aplicar-actualizar" onClick={aplicar} disabled={busy}>{busy?'Aplicando…':`Aplicar a ${dry.actualizadas}`}</button>}
      {dry && <button className="link text-xs" onClick={()=>setDry(null)}>Cancelar</button>}
    </div>
    {dry && <div className="mt-3 grid grid-cols-2 md:grid-cols-5 gap-2 text-xs">
      <Metric label="Total" value={dry.total_suscripciones}/>
      <Metric label="Actualizarían" value={dry.actualizadas} tone={dry.actualizadas?'emerald':'slate'}/>
      <Metric label="Sellado de origen" value={dry.sellado_origen||0} tone={dry.sellado_origen?'sky':'slate'} testid="metric-sellado-origen"/>
      <Metric label="Sin cambio" value={dry.sin_cambio}/>
      <Metric label="Sin casar" value={dry.sin_casar} tone={dry.sin_casar?'amber':'slate'}/>
    </div>}
    {result && <div className="mt-3 text-sm bg-emerald-50 border border-emerald-200 rounded-lg p-3">
      <p className="font-bold text-emerald-800">✓ {result.actualizadas} actualizadas · {result.sellado_origen||0} selladas de origen · {result.sin_cambio} sin cambio · {result.sin_casar} quedan como SIN_COSTE_DE_CATALOGO</p>
    </div>}
    {dry?.detalle_sin_casar?.length>0 && <SinCasarDetalle items={dry.detalle_sin_casar} total={dry.sin_casar}/>}
  </div>;
}

// Iter52.25 · Punto 3 · Tabla de detalle "Sin casar" con cliente + dispositivo,
// agrupable por codigo_plan para diagnóstico mensual sin pedir el dato aparte.
function SinCasarDetalle({items, total}){
  const [agrupar, setAgrupar] = useState(true);
  const [orden, setOrden] = useState('plan');  // 'plan' | 'cliente' | 'motivo'
  const [busca, setBusca] = useState('');
  const filtrados = useMemo(()=>{
    const q = busca.trim().toLowerCase();
    return q ? items.filter(x =>
      (x.cliente_razon_social||'').toLowerCase().includes(q) ||
      (x.dispositivo_matricula||'').toLowerCase().includes(q) ||
      (x.dispositivo_serial_geotab||'').toLowerCase().includes(q) ||
      (x.codigo_plan||'').toLowerCase().includes(q)
    ) : items;
  }, [items, busca]);
  const ordenados = useMemo(()=>{
    const cmp = {
      plan:    (a,b)=> (a.codigo_plan||'~zzz').localeCompare(b.codigo_plan||'~zzz'),
      cliente: (a,b)=> (a.cliente_razon_social||'~zzz').localeCompare(b.cliente_razon_social||'~zzz'),
      motivo:  (a,b)=> (a.motivo||'').localeCompare(b.motivo||''),
    };
    return [...filtrados].sort(cmp[orden]||cmp.plan);
  }, [filtrados, orden]);
  const agrupados = useMemo(()=>{
    if(!agrupar) return null;
    const m = new Map();
    for(const it of ordenados){
      const k = it.codigo_plan || `«${it.motivo||'sin_plan'}»`;
      if(!m.has(k)) m.set(k, []);
      m.get(k).push(it);
    }
    return [...m.entries()].sort((a,b)=> b[1].length - a[1].length);
  }, [ordenados, agrupar]);
  return <div className="mt-4 border rounded-xl overflow-hidden" data-testid="sin-casar-detalle">
    <div className="px-4 py-2 border-b bg-amber-50 flex items-center gap-3 flex-wrap">
      <b className="text-sm">Detalle "Sin casar" ({items.length} de {total} totales)</b>
      <input className="input text-xs" placeholder="Buscar cliente / matrícula / plan…" value={busca} onChange={e=>setBusca(e.target.value)} style={{maxWidth:280}} data-testid="sin-casar-busca"/>
      <label className="text-xs text-slate-600 flex items-center gap-1"><input type="checkbox" checked={agrupar} onChange={e=>setAgrupar(e.target.checked)} data-testid="sin-casar-agrupar"/> Agrupar por plan</label>
      {!agrupar && <select className="input text-xs" value={orden} onChange={e=>setOrden(e.target.value)} data-testid="sin-casar-orden">
        <option value="plan">Ordenar por plan</option>
        <option value="cliente">Ordenar por cliente</option>
        <option value="motivo">Ordenar por motivo</option>
      </select>}
      {items.length < total && <span className="text-[10px] text-slate-500 ml-auto">Truncado a los primeros {items.length}. Refina con búsqueda.</span>}
    </div>
    <div className="overflow-auto max-h-[420px]">
      {agrupar ? <table className="table text-xs">
        <thead className="sticky top-0 bg-white z-10 shadow-sm"><tr><th>Cliente</th><th>Matrícula</th><th>Serial Geotab</th><th>Régimen</th><th>Motivo</th></tr></thead>
        <tbody>{agrupados.map(([plan, subs])=>
          <React.Fragment key={plan}>
            <tr className="bg-slate-100"><td colSpan={5} className="font-mono font-bold text-[11px] py-1.5">{plan} <span className="text-slate-500 font-normal">· {subs.length} suscripciones</span></td></tr>
            {subs.map(x=>
              <tr key={x.suscripcion_id}>
                <td>{x.cliente_razon_social||<span className="text-slate-400">—</span>} {x.cliente_cif && (String(x.cliente_cif).startsWith('PENDIENTE-')
                  ? <span className="text-rose-600 text-[10px] font-semibold">· Completar CIF</span>
                  : <span className="text-slate-400 text-[10px]">· {x.cliente_cif}</span>)}</td>
                <td className="font-mono">{x.dispositivo_matricula||<span className="text-slate-400">—</span>}</td>
                <td className="font-mono">{x.dispositivo_serial_geotab||<span className="text-slate-400">—</span>}</td>
                <td>{x.dispositivo_regimen||<span className="text-slate-400">—</span>}</td>
                <td><span className={`px-1.5 py-0.5 rounded text-[10px] ${x.motivo==='sin_plan'?'bg-rose-100 text-rose-800':'bg-amber-100 text-amber-800'}`}>{x.motivo}</span></td>
              </tr>
            )}
          </React.Fragment>)}
        </tbody>
      </table> : <table className="table text-xs">
        <thead className="sticky top-0 bg-white z-10 shadow-sm"><tr><th>Cliente</th><th>Matrícula</th><th>Serial</th><th>Plan asignado</th><th>Motivo</th></tr></thead>
        <tbody>{ordenados.map(x=>
          <tr key={x.suscripcion_id}>
            <td>{x.cliente_razon_social||<span className="text-slate-400">—</span>} {x.cliente_cif && String(x.cliente_cif).startsWith('PENDIENTE-') && <span className="text-rose-600 text-[10px] font-semibold">· Completar CIF</span>}</td>
            <td className="font-mono">{x.dispositivo_matricula||<span className="text-slate-400">—</span>}</td>
            <td className="font-mono">{x.dispositivo_serial_geotab||<span className="text-slate-400">—</span>}</td>
            <td className="font-mono">{x.codigo_plan||<span className="text-slate-400">(vacío)</span>}</td>
            <td><span className={`px-1.5 py-0.5 rounded text-[10px] ${x.motivo==='sin_plan'?'bg-rose-100 text-rose-800':'bg-amber-100 text-amber-800'}`}>{x.motivo}</span></td>
          </tr>)}
        </tbody>
      </table>}
    </div>
  </div>;
}


// ════════════════════════════════════════════════════════════════════════
// Iter52.69 · Rama 17 · Registro de actividad de usuarios (super_admin).
// Solo lectura: quién hizo qué, cuándo y sobre qué.
// ════════════════════════════════════════════════════════════════════════
const ACCION_LABEL = {
  LOGIN_OK: 'Inicio de sesión',
  LOGIN_FALLIDO: 'Inicio de sesión fallido',
  EXPORTACION: 'Exportación',
  CAMBIO_PRECIO: 'Cambio de precio',
  PRECIO_INICIAL: 'Precio inicial asignado',
  SUSPENSION: 'Suspensión',
  REACTIVACION: 'Reactivación',
  BAJA: 'Baja',
  ALTA: 'Alta',
  INSTALACION: 'Instalación registrada',
  COMUNICACION_GEOTAB: 'Comunicación Geotab',
  ACTIVACION_GEOTAB: 'Activación Geotab',
  CAMBIO_PRODUCTO: 'Cambio de producto',
  CORRECCION_DATOS: 'Corrección de datos',
  CORRECCION_PERIODO: 'Corrección de periodo',
  ACTUALIZACION_CLIENTE: 'Cliente actualizado',
  ACTUALIZACION_GRUPO: 'Grupo actualizado',
  ACTUALIZACION_CIF: 'CIF actualizado',
  ALTA_FAMILIA: 'Familia creada',
  ACTUALIZACION_FAMILIA: 'Familia actualizada',
  MIGRACION_ADMIN: 'Migración de administración',
  PROPUESTAS_REGENERADAS: 'Propuestas regeneradas',
  CAMBIO_PASSWORD: 'Cambio de contraseña',
  MODELO_FACTURACION_CAMBIO: 'Cambio de modelo de facturación',
};
const RUTA_ENTIDAD = {
  SUSCRIPCION: (id)=>`/admin/saas/suscripciones?suscripcion_id=${id}`,
  DISPOSITIVO: (id)=>`/admin/saas/dispositivos/${id}`,
  CLIENTE_OPERATIVO: (id)=>`/admin/saas/dispositivos?cliente_id=${id}`,
};
const fmtMadrid = (iso)=>{
  if(!iso) return '—';
  try{
    return new Date(iso.endsWith('Z')||iso.includes('+') ? iso : iso+'Z')
      .toLocaleString('es-ES',{timeZone:'Europe/Madrid'});
  }catch(_){ return String(iso); }
};
const resumen = (v)=>{
  if(v==null) return '';
  if(typeof v!=='object') return String(v);
  // Iter52.70 · G4.2 · `ip` la puede escribir el cliente en una cabecera:
  // si no coincide con la IP real de la conexión, se muestran las dos; si
  // coinciden, una sola línea «ip».
  const o={...v};
  if(o.ip_conexion!==undefined){
    if(!o.ip || o.ip===o.ip_conexion){ o.ip=o.ip||o.ip_conexion; delete o.ip_conexion; }
  }
  return Object.entries(o).map(([k,x])=>`${k}: ${x===null||x===undefined?'—':(typeof x==='object'?JSON.stringify(x):x)}`).join(' · ');
};

function FilaActividad({ e }){
  const [abierto,setAbierto]=useState(false);
  const ruta=RUTA_ENTIDAD[e.entidad_tipo];
  const antes=resumen(e.valor_anterior), despues=resumen(e.valor_nuevo);
  const hayDetalle=!!(antes||despues);
  return <>
    <tr data-testid={`fila-actividad-${e.id}`}>
      <td className="text-xs whitespace-nowrap">{fmtMadrid(e.created_at)}</td>
      <td className="text-xs">
        <div className="font-semibold">{e.usuario_nombre}</div>
        {e.usuario_email && <div className="text-slate-400">{e.usuario_email}</div>}
      </td>
      <td className="text-xs">{ACCION_LABEL[e.tipo_evento]||e.tipo_evento}</td>
      <td className="text-xs">
        <span className="text-slate-500">{e.entidad_tipo}</span>{' '}
        {ruta ? <button className="underline text-[#0a6640] font-mono" onClick={()=>go(ruta(e.entidad_id))}>{e.entidad_id}</button>
              : <span className="font-mono">{e.entidad_id}</span>}
      </td>
      <td className="text-xs max-w-[360px]">
        {hayDetalle ? <button className="underline text-slate-600" onClick={()=>setAbierto(v=>!v)}
          data-testid={`btn-detalle-actividad-${e.id}`}>{abierto?'ocultar':'ver detalle'}</button>
          : <span className="text-slate-300">—</span>}
      </td>
      <td className="text-xs">{e.motivo||<span className="text-slate-300">—</span>}</td>
    </tr>
    {abierto && <tr className="bg-slate-50"><td/><td colSpan={5} className="text-xs text-slate-700 py-2">
      {antes && <div><b>Antes:</b> {antes}</div>}
      {despues && <div><b>Después:</b> {despues}</div>}
    </td></tr>}
  </>;
}

function Actividad(){
  const [f,setF]=useState({usuario_id:'',desde:'',hasta:'',tipo_evento:'',entidad_tipo:'',entidad_id:''});
  const [data,setData]=useState({items:[],total:0});
  const [opts,setOpts]=useState({tipos:[],entidades:[],usuarios:[]});
  const [skip,setSkip]=useState(0);
  const [cargando,setCargando]=useState(false);
  const LIMIT=100;
  const params=()=>Object.fromEntries(Object.entries(f).filter(([,v])=>v));
  const load=async(desdeSkip=skip)=>{
    setCargando(true);
    try{
      const r=await saasApi.get('/saas/admin/actividad',{params:{...params(),limit:LIMIT,skip:desdeSkip}});
      setData(r.data);
    }catch(e){ toast.error(errText(e)); } finally{ setCargando(false); }
  };
  useEffect(()=>{ saasApi.get('/saas/admin/actividad/tipos').then(r=>setOpts(r.data)).catch(()=>{}); },[]);
  useEffect(()=>{ setSkip(0); load(0); },[f.usuario_id,f.desde,f.hasta,f.tipo_evento,f.entidad_tipo,f.entidad_id]);
  const pagina=(d)=>{ const s=Math.max(0,skip+d); setSkip(s); load(s); };
  // Iter52.91 · B2 · El CSV avisa de que está trabajando.
  const {descargando,conEstadoDescarga}=useDescargas();
  const csv=()=>conEstadoDescarga('actividad-csv',async()=>{
    try{
      const r=await saasApi.get('/saas/admin/actividad/export.csv',{params:params(),responseType:'blob'});
      const url=window.URL.createObjectURL(new Blob([r.data]));
      const a=document.createElement('a'); a.href=url; a.download='actividad.csv'; a.click();
      window.URL.revokeObjectURL(url);
    }catch(e){ toast.error(errText(e)); }
  });
  return <div className="space-y-4" data-testid="tab-actividad-panel">
    <div className="bg-white border rounded-2xl p-4">
      <h2 className="font-bold text-slate-800 mb-1">Registro de actividad</h2>
      <p className="text-xs text-slate-500 mb-4">Quién hizo qué, cuándo y sobre qué. Solo lectura. Horas en Europe/Madrid.</p>
      <div className="grid md:grid-cols-6 gap-3">
        <select className="input" value={f.usuario_id} onChange={e=>setF({...f,usuario_id:e.target.value})} data-testid="filtro-actividad-usuario">
          <option value="">Todos los usuarios</option>
          {opts.usuarios.map(u=><option key={u.id} value={u.id}>{u.nombre}</option>)}
        </select>
        <input type="date" className="input" value={f.desde} onChange={e=>setF({...f,desde:e.target.value})} data-testid="filtro-actividad-desde"/>
        <input type="date" className="input" value={f.hasta} onChange={e=>setF({...f,hasta:e.target.value})} data-testid="filtro-actividad-hasta"/>
        <select className="input" value={f.tipo_evento} onChange={e=>setF({...f,tipo_evento:e.target.value})} data-testid="filtro-actividad-tipo">
          <option value="">Todas las acciones</option>
          {opts.tipos.map(t=><option key={t} value={t}>{ACCION_LABEL[t]||t}</option>)}
        </select>
        <select className="input" value={f.entidad_tipo} onChange={e=>setF({...f,entidad_tipo:e.target.value})} data-testid="filtro-actividad-entidad">
          <option value="">Todas las entidades</option>
          {opts.entidades.map(t=><option key={t} value={t}>{t}</option>)}
        </select>
        <input className="input" placeholder="Id de entidad (opcional)" value={f.entidad_id}
               onChange={e=>setF({...f,entidad_id:e.target.value})} data-testid="filtro-actividad-entidad-id"/>
      </div>
      <div className="flex justify-between items-center mt-3">
        <span className="text-xs text-slate-500">{data.total} registros</span>
        <button className="btn-secondary btn-sm disabled:opacity-60 disabled:cursor-not-allowed" disabled={descargando('actividad-csv')} onClick={csv} data-testid="btn-actividad-csv">{descargando('actividad-csv')?'Generando…':'Descargar CSV'}</button>
      </div>
    </div>
    <div className="bg-white border rounded-2xl overflow-hidden">
      <table className="table" data-testid="tabla-actividad">
        <thead><tr><th>Fecha y hora</th><th>Usuario</th><th>Acción</th><th>Entidad</th><th>Detalle</th><th>Motivo</th></tr></thead>
        <tbody>
          {cargando && <tr><td colSpan={6} className="text-center text-slate-400 py-6">Cargando…</td></tr>}
          {!cargando && !data.items.length && <tr><td colSpan={6} className="text-center text-slate-400 py-6">Sin actividad con estos filtros.</td></tr>}
          {!cargando && data.items.map(e=><FilaActividad key={e.id||`${e.created_at}-${e.entidad_id}`} e={e}/>)}
        </tbody>
      </table>
      {data.total>LIMIT && <div className="flex justify-between items-center p-3 border-t text-xs">
        <button className="btn-secondary btn-sm" disabled={skip===0} onClick={()=>pagina(-LIMIT)} data-testid="btn-actividad-anterior">Anteriores</button>
        <span className="text-slate-500">{skip+1}–{Math.min(skip+LIMIT,data.total)} de {data.total}</span>
        <button className="btn-secondary btn-sm" disabled={skip+LIMIT>=data.total} onClick={()=>pagina(LIMIT)} data-testid="btn-actividad-siguiente">Siguientes</button>
      </div>}
    </div>
  </div>;
}
